webpackJsonp([1],{

/***/ "+/SB":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("CaBU");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("811c6acc", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-41bd5494\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Project.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-41bd5494\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Project.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "/QVs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThisMonth_vue__ = __webpack_require__("nK8i");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_540d8e12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThisMonth_vue__ = __webpack_require__("5RCi");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThisMonth_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_540d8e12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThisMonth_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/People/ThisMonth.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-540d8e12", Component.options)
  } else {
    hotAPI.reload("data-v-540d8e12", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0G7d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-navigation-drawer",
    {
      staticClass: "white sidebar",
      attrs: {
        fixed: "",
        permanent: "",
        "mini-variant": true,
        "mini-variant-width": 60
      }
    },
    [
      _c(
        "div",
        { staticClass: "person-selector-container" },
        _vm._l(_vm.people, function(person) {
          return _c(
            "div",
            {
              key: person.fName + person.lName,
              class: [
                person === _vm.selectedPerson ? "selected-person" : "",
                "person"
              ],
              on: {
                click: function($event) {
                  return _vm.selectPerson(person)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "person-image-holder temp-name-container" },
                [
                  _c("img", {
                    staticClass: "person-image",
                    attrs: {
                      src: "https://cdn.vuetifyjs.com/images/cards/road.jpg"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "temp-name-text" }, [
                    _vm._v(_vm._s(person.fName))
                  ])
                ]
              )
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3570c818", esExports)
  }
}

/***/ }),

/***/ "1+6L":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.clickable-row[data-v-befa09e2]{\n  cursor: pointer;\n}\n.dark-on-hover[data-v-befa09e2]{\n  padding: 10px 20px;\n  margin: -10px 0px;\n}\n.dark-on-hover[data-v-befa09e2]:hover{\n  background-color: rgba(0, 0, 0, 0.03);\n}\n", ""]);

// exports


/***/ }),

/***/ "16gp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store___ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_service_database__ = __webpack_require__("LLs5");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  firebase: {
    projectsManagementDetailsView: __WEBPACK_IMPORTED_MODULE_1__vue_service_database__["m" /* projectManagementDetailsViewRef */]
  },
  computed: {
    selectedProjectKey: function selectedProjectKey() {
      return this.$store.getters.selectedProjectKey;
    },
    projectsManagementDetails: function projectsManagementDetails() {
      return this.$store.getters.projectsManagementDetails;
    },
    project: function project() {
      return this.$store.getters.project;
    },
    peopleEmails: function peopleEmails() {
      var people = this.$store.getters.people;
      var emails = [];
      for (var person in people) {
        emails.push(people[person].email);
      }
      return emails;
    },
    statusStyle: function statusStyle() {
      var project = this.$store.getters.project;
      if (project.updateStatus == "3 - green") {
        return { "light-green darken-2": true };
      } else if (project.updateStatus == "2 - yellow") {
        return { "amber darken-1": true };
      } else if (project.updateStatus == "1 - red") {
        return { "red darken-2": true };
      } else {
        return { grey: true };
      }
    },
    todaysDate: function todaysDate() {
      var currentDate = new Date();
      return currentDate.toLocaleDateString("en-US");
    }
  },
  methods: {
    updateProjectLead: function updateProjectLead() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__vue_service_database__["n" /* projectsLeadsRef */].once("value", function (snapshot) {
        var projectsLeads = snapshot.val();
        var newLeadProps = {
          id: _this.project.id,
          leadName: _this.project.leadName
        };
        var isNew = true;
        for (var key in projectsLeads) {
          if (projectsLeads[key].id == _this.project.id) {
            isNew = false;
            __WEBPACK_IMPORTED_MODULE_1__vue_service_database__["n" /* projectsLeadsRef */].child(key).update(newLeadProps);
          }
        }
        if (isNew) {
          __WEBPACK_IMPORTED_MODULE_1__vue_service_database__["n" /* projectsLeadsRef */].push(newLeadProps);
        }
      });
    },
    pushProjectUpdate: function pushProjectUpdate() {
      var update = {
        id: this.project.id,
        updateTimestamp: this.todaysDate,
        updateText: this.project.updateText,
        updateStatus: this.project.updateStatus
      };
      __WEBPACK_IMPORTED_MODULE_1__vue_service_database__["o" /* projectsUpdatesRef */].push(update);
    }
  },
  data: function data() {
    return {
      editProjectOpen: false,
      editStatusOpen: false,
      projectStatuses: ["3 - green", "2 - yellow", "1 - red"],
      editLeadOpen: false,
      editUpdateOpen: false,
      projectStatusGreen: false,
      projectStatusYellow: false,
      projectStatusRed: false,
      headersProject: [{
        text: "Updated On",
        align: "left",
        sortable: true,
        value: "updateTimestamp"
      }, {
        text: "Update Details",
        align: "left",
        sortable: false,
        value: "updateText"
      }, {
        text: "Status",
        align: "left",
        sortable: true,
        value: "updateStatus"
      }]
    };
  }
});

/***/ }),

/***/ "19Us":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.sidebar[data-v-6c5cc5f4]{\n  position: fixed;\n  top: 64px !important;\n  z-index: 11;\n  height: calc(100% - 64px) !important;\n}\n.sidebar-list[data-v-6c5cc5f4]{\n  padding-top: 0px;\n}\n.list-item[data-v-6c5cc5f4]{\n  height: 80px !important;\n}\n.selected[data-v-6c5cc5f4]{\n  background-color: rgb(255, 255, 255, 0.3);\n  border-width: 0px 0px 0px 3px;\n  border-color: white;\n  border-style: solid;\n  padding-left: -3px;\n}\n.link-icon[data-v-6c5cc5f4]{\n  padding: 20px;\n  margin: -20px;\n}\n", ""]);

// exports


/***/ }),

/***/ "1vc+":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("OyH4");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("33d6423a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ea413962\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Skills.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ea413962\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Skills.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "4HDL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Skills_vue__ = __webpack_require__("YY3s");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea413962_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Skills_vue__ = __webpack_require__("vSLk");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("1vc+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ea413962"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Skills_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea413962_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Skills_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Skills/Skills.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ea413962", Component.options)
  } else {
    hotAPI.reload("data-v-ea413962", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4q66":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_service_selected_person__ = __webpack_require__("MsY1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PeopleNavigation_vue__ = __webpack_require__("NPRX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PeopleFilters_vue__ = __webpack_require__("IlOy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PersonPage_vue__ = __webpack_require__("hIHY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PersonSelector_vue__ = __webpack_require__("6skR");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    "people-nav": __WEBPACK_IMPORTED_MODULE_3__PeopleNavigation_vue__["a" /* default */],
    "people-filters": __WEBPACK_IMPORTED_MODULE_4__PeopleFilters_vue__["a" /* default */],
    "person-page": __WEBPACK_IMPORTED_MODULE_5__PersonPage_vue__["a" /* default */],
    "person-selector": __WEBPACK_IMPORTED_MODULE_6__PersonSelector_vue__["a" /* default */]
  },
  data: function data() {
    return {
      search: "",
      showInactive: false,
      viewingProfile: false,
      filters: {}
    };
  },

  computed: {
    filteredPeople: function filteredPeople() {
      var _this = this;

      var filtered = [];

      // Get the correct search set
      for (var key in this.$store.getters.people) {
        var person = this.$store.getters.people[key];

        // If the search contains the person's name or email, keep them
        if (this.search ? person.fName.toLowerCase().includes(this.search.toLowerCase()) || person.lName.toLowerCase().includes(this.search.toLowerCase()) || (person.fName + person.lName).toLowerCase().includes(this.search.toLowerCase()) || person.email.toLowerCase().includes(this.search.toLowerCase()) : true) {
          // If the person is active or inactive people are being shown (in addition to new ones)
          // Perhaps this should be xor
          if (person.active || this.showInactive) {
            filtered.push(person);
          }
        }
      }

      // Apply filters
      filtered = filtered.filter(function (person) {
        for (var _key in _this.filters) {
          // For each of the filters
          var filter = _this.filters[_key];
          // If there is anything in the filter
          if (filter !== []) {
            // If person does not have the key, they cannot possibly match the filter
            if (person[_key] === undefined) return false;

            // Assume the person does not fall into the category
            var withinFilter = false;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(filter), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                // If they do match an item in the filter, say so
                if (item.toLowerCase() === person[_key].toLowerCase()) {
                  withinFilter = true;
                }
              }

              // If they made it through the filter without matching anything, exclude them
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            if (!withinFilter) {
              return false;
            }
          }
        }
        //If they matched all filters or there were no filters, return true
        return true;
      });

      // Return the people sorted by full name
      return filtered.sort(function (personA, personB) {
        var a = personA.fName + " " + personA.lName;
        var b = personB.fName + " " + personB.lName;
        return a < b ? -1 : b < a ? 1 : 0;
      });
    }
  },
  methods: {
    scrollToTop: function scrollToTop() {
      window.scrollTo(0, 0);
    },
    handleSearch: function handleSearch(searchTerm) {
      this.search = searchTerm;
    },
    handleChangeFilter: function handleChangeFilter(id, value) {
      // If the clear all button sent this signal, clear all filters
      if (id === "clearAll") {
        this.filters = {};
      } else {
        // Otherwise, apply the filters to a new object to trigger an update
        var newObj = {};
        newObj[id] = value;
        this.filters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.filters, newObj);
      }
    },
    handleShowInactive: function handleShowInactive(value) {
      this.showInactive = value;
    },
    selectPerson: function selectPerson(person) {
      this.viewingProfile = true;
      var key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__vue_service_selected_person__["b" /* getPersonsPushId */])(person.email);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__vue_service_selected_person__["c" /* setSelected */])(key);
    },
    handleBack: function handleBack() {
      this.viewingProfile = false;
    }
  }
});

/***/ }),

/***/ "5Jaz":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("HOXW");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("14e2a35c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3570c818\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PersonSelector.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3570c818\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PersonSelector.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "5RCi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c(
        "v-toolbar",
        { staticClass: "primary darken" },
        [
          _c("v-toolbar-title", { staticClass: "white--text" }, [
            _vm._v("This Month")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-container",
        { attrs: { "grid-list-md": "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { sm12: "", md6: "" } },
                [
                  _vm.birthdaysThisMonth === null
                    ? _c(
                        "v-container",
                        [
                          _c("v-progress-circular", {
                            attrs: { color: "primary", indeterminate: "" }
                          })
                        ],
                        1
                      )
                    : _c(
                        "v-card",
                        { staticClass: " " },
                        [
                          _c(
                            "v-card-title",
                            { staticClass: "primary darken white--text" },
                            [
                              _vm._v(
                                "\n                    Birthdays\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-data-table", {
                            attrs: {
                              light: "",
                              headers: _vm.headersBirthday,
                              items: _vm.birthdaysThisMonth,
                              "hide-default-footer": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "items",
                                fn: function(props) {
                                  return [
                                    _c("tr", [
                                      _c("td", [
                                        _vm._v(_vm._s(props.item.name))
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(_vm._s(props.item.birthDate))
                                      ])
                                    ])
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { sm12: "", md6: "" } },
                [
                  _vm.anniversariesThisMonth === null
                    ? _c(
                        "v-container",
                        [
                          _c("v-progress-circular", {
                            attrs: { color: "primary", indeterminate: "" }
                          })
                        ],
                        1
                      )
                    : _c(
                        "v-card",
                        {},
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass:
                                "tile-contacts primary darken white--text"
                            },
                            [
                              _vm._v(
                                "\n                    Anniversaries\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-data-table", {
                            attrs: {
                              light: "",
                              headers: _vm.headersAnniversaries,
                              items: _vm.anniversariesThisMonth,
                              "hide-default-footer": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "items",
                                fn: function(props) {
                                  return [
                                    _c("tr", [
                                      _c("td", [
                                        _vm._v(_vm._s(props.item.name))
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(_vm._s(props.item.years))
                                      ])
                                    ])
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-540d8e12", esExports)
  }
}

/***/ }),

/***/ "5VcY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-content",
    [
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { push: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "primary" },
                    [
                      _c(
                        "v-card-title",
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "icon-space white--text",
                              attrs: { left: "" }
                            },
                            [_vm._v("group")]
                          ),
                          _vm._v(" "),
                          _c("h5", { staticClass: "title white--text" }, [
                            _vm._v("FIND GROUPS")
                          ]),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: {
                              dark: "",
                              "append-icon": "search",
                              label: "Search",
                              "single-line": "",
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.searchGroup,
                              callback: function($$v) {
                                _vm.searchGroup = $$v
                              },
                              expression: "searchGroup"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-data-table", {
                        staticClass: "secondary",
                        attrs: {
                          headers: _vm.headersGroup,
                          items: _vm.groups,
                          search: _vm.searchGroup,
                          "items-per-page-options": [
                            5,
                            15,
                            25,
                            { text: "All", value: -1 }
                          ]
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "tr",
                                  {
                                    staticClass: "clickable-row",
                                    on: {
                                      click: function($event) {
                                        return _vm.selectGroup(item.key)
                                      }
                                    }
                                  },
                                  [
                                    _c("td", [_vm._v(_vm._s(item.name))]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(item.email))])
                                  ]
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _vm.selectedGroup
                        ? _c("v-card-text", [
                            _c("h1", { staticClass: "white--text" }, [
                              _vm._v(_vm._s(_vm.selectedGroup.name))
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedGroup
                        ? _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            _vm._l(_vm.selectedGroupMembers, function(
                              item,
                              index
                            ) {
                              return _c(
                                "v-list-item",
                                { key: index },
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", {
                                        staticClass:
                                          "clickable-row dark-on-hover",
                                        domProps: { textContent: _vm._s(item) },
                                        on: {
                                          click: function($event) {
                                            return _vm.selectMemberFromEmail(
                                              item
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { push: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "primary" },
                    [
                      _c(
                        "v-card-title",
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "icon-space white--text",
                              attrs: { left: "" }
                            },
                            [_vm._v("group")]
                          ),
                          _vm._v(" "),
                          _c("h5", { staticClass: "title white--text" }, [
                            _vm._v("FIND PEOPLE")
                          ]),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: {
                              dark: "",
                              "append-icon": "search",
                              label: "Search",
                              "single-line": "",
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.searchEmail,
                              callback: function($$v) {
                                _vm.searchEmail = $$v
                              },
                              expression: "searchEmail"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-data-table", {
                        staticClass: "secondary",
                        attrs: {
                          headers: _vm.headersPerson,
                          items: _vm.activePersons,
                          search: _vm.searchEmail,
                          "items-per-page-options": [
                            5,
                            15,
                            25,
                            { text: "All", value: -1 }
                          ]
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "tr",
                                  {
                                    staticClass: "clickable-row",
                                    on: {
                                      click: function($event) {
                                        return _vm.selectMember(item.key)
                                      }
                                    }
                                  },
                                  [
                                    _c("td", [_vm._v(_vm._s(item.fName))]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(item.lName))]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(item.email))])
                                  ]
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _vm.selectedMember
                        ? _c("v-card-text", [
                            _c("h1", { staticClass: "white--text" }, [
                              _vm._v(_vm._s(_vm.selectedMember))
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedMember
                        ? _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            _vm._l(_vm.selectedMemberships, function(
                              item,
                              index
                            ) {
                              return _c(
                                "v-list-item",
                                { key: index },
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", {
                                        staticClass:
                                          "clickable-row dark-on-hover",
                                        domProps: {
                                          textContent: _vm._s(item.name)
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.selectGroup(item.id)
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-befa09e2", esExports)
  }
}

/***/ }),

/***/ "5l9i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__("ikxi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["chartData", "options"],
  mounted: function mounted() {
    var chart = document.getElementById("project-chart");
    this.myChart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(chart, {
      type: 'doughnut',
      data: this.chartData,
      options: {
        legend: {
          display: false
        }
      },
      responsive: true,
      maintainAspectRatio: false
    });
  }
});

/***/ }),

/***/ "5v62":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-layout", { attrs: { row: "" } }),
      _vm._v(" "),
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-card",
            {
              staticClass: "mx-auto",
              attrs: { "max-width": "344", outlined: "" }
            },
            [
              _c(
                "v-list-item",
                { attrs: { "three-line": "" } },
                [
                  _c(
                    "v-list-item-content",
                    [
                      _c("div", { staticClass: "overline mb-4" }, [
                        _vm._v("DANGEROUS")
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-list-item-title",
                        { staticClass: "headline mb-1" },
                        [_vm._v("Find Missing Tech Props")]
                      ),
                      _vm._v(" "),
                      _c("v-list-item-subtitle", [
                        _vm._v(
                          "Find who is missing tech props and in which skill."
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary--text filter-item",
                      attrs: { outlined: "" },
                      on: {
                        click: function($event) {
                          return _vm.findMissingTech()
                        }
                      }
                    },
                    [_vm._v("FIND")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm10: "", "offset-sm1": "" } },
                [
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        color: "info",
                        icon: "warning",
                        dismissible: ""
                      },
                      model: {
                        value: _vm.isDuplicateEmail,
                        callback: function($$v) {
                          _vm.isDuplicateEmail = $$v
                        },
                        expression: "isDuplicateEmail"
                      }
                    },
                    [
                      _c(
                        "span",
                        { staticStyle: { color: "red", "font-size": "1.3em" } },
                        [
                          _vm._v(
                            "Woah, slow down there, Slappy. That email is already in the list."
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "" } },
            [
              _c(
                "v-flex",
                { attrs: { sm2: "", "offset-sm1": "", md2: "", lg1: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green", fab: "", small: "" },
                      on: {
                        click: function($event) {
                          return _vm.addAdministrator(_vm.administratorsRef)
                        }
                      }
                    },
                    [
                      _c("v-icon", { staticClass: "white--text" }, [
                        _vm._v("add")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs8: "", lg9: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: "E-mail",
                      rules: [_vm.rules.required, _vm.rules.email]
                    },
                    model: {
                      value: _vm.email,
                      callback: function($$v) {
                        _vm.email = $$v
                      },
                      expression: "email"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", sm10: "", "offset-sm1": "" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    { staticClass: "primary white--text" },
                    [
                      _c("v-toolbar-title", [_vm._v("Administrators")]),
                      _vm._v(" "),
                      _c("v-spacer")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    _vm._l(_vm.administrators, function(administrator) {
                      return _c(
                        "v-list-item",
                        { key: administrator[".key"], attrs: { avatar: "" } },
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", {
                                domProps: {
                                  textContent: _vm._s(administrator.email)
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-avatar",
                            [
                              _c(
                                "v-dialog",
                                {
                                  attrs: { persistent: "" },
                                  model: {
                                    value: _vm.deleteDialog,
                                    callback: function($$v) {
                                      _vm.deleteDialog = $$v
                                    },
                                    expression: "deleteDialog"
                                  }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        slot: "activator",
                                        color: "error",
                                        fab: "",
                                        small: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.setAdministratorKey(
                                            administrator[".key"]
                                          )
                                        }
                                      },
                                      slot: "activator"
                                    },
                                    [_c("v-icon", [_vm._v("delete")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-card-title",
                                        { staticClass: "headline" },
                                        [_vm._v("Remove Administrator?")]
                                      ),
                                      _vm._v(" "),
                                      _c("v-card-text", [
                                        _vm._v(
                                          "Are you sure you want to remove " +
                                            _vm._s(
                                              _vm.selectedAdministrator.email
                                            ) +
                                            " from the list of Administrators?"
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-card-actions",
                                        [
                                          _c("v-spacer"),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "darken-1",
                                                flat: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.deleteDialog = false
                                                }
                                              }
                                            },
                                            [_vm._v("Cancel")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "darken-1",
                                                flat: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.removeAdministrator(
                                                    _vm.selectedAdministrator
                                                      .key
                                                  )
                                                  _vm.deleteDialog = false
                                                }
                                              }
                                            },
                                            [_vm._v("Remove")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-538ddd6a", esExports)
  }
}

/***/ }),

/***/ "64p4":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("skFd");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0567aeaf", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0cce41e2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Projects.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0cce41e2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Projects.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "69nz":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("r3lP");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("78274e8a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-81440b78\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Navigation.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-81440b78\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Navigation.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "6CNk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: _vm.idName }, on: { click: _vm.generate } },
    [
      _vm._t("default", [_vm._v("\n\t\tDownload " + _vm._s(_vm.name) + "\n\t")])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fb865680", esExports)
  }
}

/***/ }),

/***/ "6p4m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProjectChart_vue__ = __webpack_require__("jjyn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_service_person_js__ = __webpack_require__("h8tr");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    "project-chart": __WEBPACK_IMPORTED_MODULE_3__ProjectChart_vue__["a" /* default */]
  },
  data: function data() {
    return {
      currentItem: "tab-Contact",
      leftItems: ["Contact", "Employment", "Misc."],
      leftLayout: {
        "Personal": [{ label: "Work Email", id: "email", requiresUser: false, requiresAdmin: false }, { label: "ONSIP Extension", id: "onsipExtension", requiresUser: false, requiresAdmin: false }, { label: "Personal Email", id: "email1", requiresUser: false, requiresAdmin: false }, { label: "Mobile Number", id: "phone1", requiresUser: false, requiresAdmin: false }, { label: "Street", id: "street", requiresUser: true, requiresAdmin: false }, { label: "City", id: "city", requiresUser: true, requiresAdmin: false }, { label: "Zip", id: "zip", requiresUser: true, requiresAdmin: false }],
        "Employment": [{ label: "Start Date", id: "startDate", requiresUser: false, requiresAdmin: false }, { label: "Status", id: "status", requiresUser: false, requiresAdmin: false }, { label: "Active Employee", id: "active", requiresUser: false, requiresAdmin: false }, { label: "Group", id: "group", requiresUser: false, requiresAdmin: false }, { label: "Kelmar ID", id: "kelmarId", requiresUser: true, requiresAdmin: false }],
        "Contact": [{ label: "Share Birthday", id: "shareBirthDate", requiresUser: true, requiresAdmin: false }, { label: "Birthday", id: "birthDate", requiresUser: true, requiresAdmin: false }, { label: "Emergency Contact", id: "emergencyName", requiresUser: true, requiresAdmin: false }, { label: "Contact Relationship", id: "emergencyRelationship", requiresUser: true, requiresAdmin: false }, { label: "Contact Phone", id: "emergencyPhone1", requiresUser: true, requiresAdmin: false }],
        "Misc.": [{ label: "Share Birthday", id: "shareBirthDate", requiresUser: true, requiresAdmin: false }, { label: "Birthday", id: "birthDate", requiresUser: true, requiresAdmin: false }, { label: "Emergency Contact", id: "emergencyName", requiresUser: true, requiresAdmin: false }, { label: "Contact Relationship", id: "emergencyRelationship", requiresUser: true, requiresAdmin: false }, { label: "Contact Phone", id: "emergencyPhone1", requiresUser: true, requiresAdmin: false }]
      },
      chartData: {
        labels: ["Project1", "Project2"],
        datasets: [{
          label: 'Red',
          backgroundColor: ["#1198aa", "#88CCD5"],
          data: [25, 75]
        }]
      },
      editing: { "Contact": false, "Employment": false, "Misc.": false },
      editedItems: {
        "Contact": {
          email: "",
          email1: "",
          onsipExtension: "",
          phone1: "",
          street: "",
          city: "",
          zip: ""
        },
        "Employment": {
          startDate: "",
          status: "",
          active: "",
          group: "",
          kelmarId: ""
        },
        "Misc.": {
          shareBirthDate: "",
          birthDate: "",
          emergencyName: "",
          emergencyRelationship: "",
          emergencyPhone1: ""
        }
      },
      editingSH: false,
      SHopenTo: "",
      SHnumHours: "",
      SHpreferences: "",
      editingName: false,
      nameFields: { fName: "", lName: "", nName: "", group: "" },
      prevSelectedPerson: null,
      dialog: false,
      pendingEdit: null,
      pendingArgs: []
    };
  },

  computed: {
    selectedPerson: function selectedPerson() {
      var person = this.$store.getters.people[this.$store.getters.selectedPersonKey];
      if (this.prevSelectedPerson !== null && this.prevSelectedPerson !== person) {
        // Different Person
        for (var key in this.editing) {
          this.editing[key] = false;
        }
        this.editingName = false;
        this.editingSH = false;
      }
      this.prevSelectedPerson = person;
      return person;
    },
    selectedPersonSkillsRating2: function selectedPersonSkillsRating2() {
      var technologies = this.$store.getters.technology;
      var skills = this.$store.getters.selectedPersonSkillsRating;
      var rating2Skills = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(skills).filter(function (key) {
        return skills[key].Rating === 2;
      }).map(function (key) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ key: key }, technologies[key]);
      });
      if (rating2Skills.length === 0) {
        return [{ key: 1, Name: "None" }];
      }
      return rating2Skills;
    },
    selectedPersonSkillsRating3: function selectedPersonSkillsRating3() {
      var technologies = this.$store.getters.technology;
      var skills = this.$store.getters.selectedPersonSkillsRating;
      var rating3Skills = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(skills).filter(function (key) {
        return skills[key].Rating === 3;
      }).map(function (key) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ key: key }, technologies[key]);
      });
      if (rating3Skills.length === 0) {
        return [{ key: 1, Name: "None" }];
      }
      return rating3Skills;
    },
    userIsAdmin: function userIsAdmin() {
      return this.$store.getters.administrator;
    },
    userIsSelected: function userIsSelected() {
      return this.$store.getters.selectedPersonIsUser;
    }
  },
  methods: {
    scopedItems: function scopedItems(items) {
      var _this = this;

      return items.filter(function (item) {
        return (!item.requiresAdmin || _this.userIsAdmin) && (!item.requiresUser || _this.userIsAdmin || _this.userIsSelected);
      });
    },
    startEditing: function startEditing(item) {
      for (var field in this.editedItems[item]) {
        this.editedItems[item][field] = this.selectedPerson[field];
      }
      this.editing[item] = !this.editing[item];
    },
    saveEdits: function saveEdits(item) {
      this.editing[item] = false;

      // Merge the current person with their edited data, then save the whole thing to firebase
      var basePerson = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.selectedPerson);
      for (var key in this.editedItems[item]) {
        var field = this.editedItems[item][key];
        if (field !== undefined) {
          basePerson[key] = field;
        }
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__vue_service_person_js__["a" /* updatePersonInfo */])(this.selectedPerson.email, basePerson);
    },
    startEditingName: function startEditingName() {
      for (var field in this.nameFields) {
        this.nameFields[field] = this.selectedPerson[field];
      }
      this.editingName = !this.editingName;
    },
    saveNameEdits: function saveNameEdits() {
      this.editingName = false;

      var basePerson = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.selectedPerson);
      for (var key in this.nameFields) {
        var field = this.nameFields[key];
        if (field !== undefined) {
          basePerson[key] = field;
        }
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__vue_service_person_js__["a" /* updatePersonInfo */])(this.selectedPerson.email, basePerson);
    },
    changeEditing: function changeEditing(func) {
      var editing = false;
      for (var key in this.editing) {
        editing = editing || this.editing[key];
      }

      // If the user is already editing something, warn them and save the pending edit

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (editing || this.editingName || this.editingSH) {
        this.dialog = true;
        this.pendingEdit = func;
        this.pendingArgs = args;
      } else {
        // If not, go to the new edit
        func.apply(undefined, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args));
      }
    },
    continueWithUnsavedChanges: function continueWithUnsavedChanges() {
      // If the user doesn't care about their unsaved changes, clear their edits and go to the next edit
      this.dialog = false;
      for (var key in this.editing) {
        this.editing[key] = false;
      }
      this.editingName = false;
      this.editingSH = false;
      this.pendingEdit.apply(this, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.pendingArgs));
    }
  }
});

/***/ }),

/***/ "6skR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PersonSelector_vue__ = __webpack_require__("orMY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3570c818_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PersonSelector_vue__ = __webpack_require__("0G7d");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("5Jaz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3570c818"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PersonSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3570c818_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PersonSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/People/PersonSelector.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3570c818", Component.options)
  } else {
    hotAPI.reload("data-v-3570c818", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9y5z":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("z/SG");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("6ef27da5", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-71fef2af\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./People.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-71fef2af\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./People.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "AQSN":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.people-navbar[data-v-e8e6a3ba]{\n  position: fixed;\n  margin: -12px 0px 0px -12px;\n  width: calc(100% - 80px);\n  max-width: calc(100% - 80px);\n  z-index: 8;\n}\n.space[data-v-e8e6a3ba]{\n  width: 78px;\n}\n.view-sheet-icon[data-v-e8e6a3ba]{\n  margin-top: 10px;\n  margin-left: 30px;\n}\n.back-icon[data-v-e8e6a3ba]{\n  margin-right: 15px;\n}\n.people-logo[data-v-e8e6a3ba]{\n  text-transform: uppercase;\n  color: rgb(100, 100, 100);\n  font-weight: bold;\n}\n.active-logo[data-v-e8e6a3ba]{\n  margin-left: 80px;\n  cursor: pointer;\n}\n", ""]);

// exports


/***/ }),

/***/ "BE4E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-bar" },
    [
      _c(
        "v-flex",
        { staticClass: "align-self-end filter-select" },
        [
          _c("v-label", [_vm._v("Role")]),
          _vm._v(" "),
          _c("v-select", {
            staticClass: "filter-item",
            attrs: {
              items: _vm.roleCategories,
              placeholder: "All",
              multiple: "",
              "hide-default-footer": "",
              dense: ""
            },
            on: {
              input: function($event) {
                return _vm.onFilter("group", $event)
              }
            },
            model: {
              value: _vm.role,
              callback: function($$v) {
                _vm.role = $$v
              },
              expression: "role"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { staticClass: "align-self-end filter-select" },
        [
          _c("v-label", [_vm._v("Work Location")]),
          _vm._v(" "),
          _c("v-select", {
            staticClass: "filter-item",
            attrs: {
              items: _vm.workLocationCategories,
              placeholder: "All",
              multiple: "",
              "hide-default-footer": "",
              dense: ""
            },
            on: {
              input: function($event) {
                return _vm.onFilter("workLocation", $event)
              }
            },
            model: {
              value: _vm.workLocation,
              callback: function($$v) {
                _vm.workLocation = $$v
              },
              expression: "workLocation"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { staticClass: "align-self-end filter-select" },
        [
          _c("v-label", [_vm._v("Project Allocation")]),
          _vm._v(" "),
          _c("v-select", {
            staticClass: "filter-item",
            attrs: {
              items: _vm.projectAllocationCategories,
              placeholder: "All",
              multiple: "",
              "hide-default-footer": "",
              dense: ""
            },
            on: {
              input: function($event) {
                return _vm.onFilter("projectAllocation", $event)
              }
            },
            model: {
              value: _vm.projectAllocation,
              callback: function($$v) {
                _vm.projectAllocation = $$v
              },
              expression: "projectAllocation"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { staticClass: "align-self-end filter-select" },
        [
          _c("v-label", [_vm._v("Side Hustle")]),
          _vm._v(" "),
          _c("v-select", {
            staticClass: "filter-item",
            attrs: {
              items: _vm.sideHustleCategories,
              placeholder: "All",
              multiple: "",
              "hide-default-footer": "",
              dense: ""
            },
            on: {
              input: function($event) {
                return _vm.onFilter("sideHustle", $event)
              }
            },
            model: {
              value: _vm.sideHustle,
              callback: function($$v) {
                _vm.sideHustle = $$v
              },
              expression: "sideHustle"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { staticClass: "align-self-end filter-select" },
        [
          _c("v-label", [_vm._v("Employment Type")]),
          _vm._v(" "),
          _c("v-select", {
            staticClass: "filter-item",
            attrs: {
              items: _vm.employmentTypeCategories,
              placeholder: "All",
              multiple: "",
              "hide-default-footer": "",
              dense: ""
            },
            on: {
              input: function($event) {
                return _vm.onFilter("status", $event)
              }
            },
            model: {
              value: _vm.employmentType,
              callback: function($$v) {
                _vm.employmentType = $$v
              },
              expression: "employmentType"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("v-checkbox", {
        staticClass: "filter-item-checkbox",
        attrs: { label: "Show Inactive" },
        on: {
          change: function($event) {
            return _vm.onChangeInactive()
          }
        },
        model: {
          value: _vm.showInactive,
          callback: function($$v) {
            _vm.showInactive = $$v
          },
          expression: "showInactive"
        }
      }),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "primary--text spacing",
          attrs: { outlined: "" },
          on: { click: _vm.clearFilters }
        },
        [_vm._v("Clear Filters")]
      ),
      _vm._v(" "),
      _c("add-person")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e395e08", esExports)
  }
}

/***/ }),

/***/ "BsXh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-toolbar",
        {
          staticClass: "white people-navbar",
          attrs: { height: "80px", flat: "", fixed: "" }
        },
        [
          _c("v-toolbar-title", [
            _c(
              "div",
              {
                class: [_vm.viewingProfile ? "active-logo" : "", "people-logo"],
                on: {
                  click: function($event) {
                    return _vm.handleClick()
                  }
                }
              },
              [
                _vm.viewingProfile
                  ? _c(
                      "v-icon",
                      { staticClass: "back-icon", attrs: { medium: "" } },
                      [_vm._v("keyboard_backspace")]
                    )
                  : _vm._e(),
                _vm._v("People")
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c("v-text-field", {
            attrs: {
              "hide-details": "",
              "append-icon": "search",
              "single-line": "",
              placeholder: "Search by name or email"
            },
            on: {
              input: function($event) {
                return _vm.onInput($event)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "v-icon",
            { staticClass: "view-sheet-icon", attrs: { medium: "" } },
            [_vm._v("note")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e8e6a3ba", esExports)
  }
}

/***/ }),

/***/ "CBkA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return syncApis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return postToday; });
/* unused harmony export postUpdateSheet */
/* unused harmony export postSignatoryStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updatePersonsGSuiteStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return postGroupsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return postOnsipUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return postSlackActiveUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return updateSlackActiveUsersPublicChannels; });
/* unused harmony export postDates */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store___ = __webpack_require__("IcnI");


function startFunctionRequest(endpoint) {
	// URL to Express Middleware that validates JWT token for all requests
	// Webpack process.env is in /build/webpack.*.confi.js
	var cloudfunctionsUrl = "https://us-central1-issy-development.cloudfunctions.net/app" + endpoint;
	// console.log('Building request to', cloudfunctionsUrl, 'with ID token in Authorization header.')
	var req = new XMLHttpRequest();
	req.onload = function () {
		// console.log('API Request - Started')
	};
	req.onerror = function () {
		console.log("onerror - responseText: ", req.responseText);
	};
	req.open("GET", cloudfunctionsUrl, true);
	req.setRequestHeader("Authorization", "Bearer " + __WEBPACK_IMPORTED_MODULE_0__store___["a" /* default */].getters.token);
	return req;
}

function syncApis() {
	var req = startFunctionRequest("/syncApis");
	req.onload = function () {
		// console.log('API Request - syncApis: Complete')
		// console.log('onload - responseText: ', req.responseText)
	};
	req.send();
}

function postToday() {
	var req = startFunctionRequest("/postToday");
	req.onload = function () {
		// console.log('API Request - postToday: Complete')
		// console.log('onload - responseText: ', req.responseText)
	};
	req.send();
}

function updatePersonsGSuiteStatus() {
	var req = startFunctionRequest("/updatePersonsGSuiteStatus");
	req.onload = function () {
		// console.log('API Request - updatePersonsGSuiteStatus: Complete')
		// console.log('onload - responseText: ', req.responseText)
	};
	req.send();
}

function postGroupsData() {
	var req = startFunctionRequest("/postGroupsData");
	req.onload = function () {
		// console.log('API Request - postGroupsData: Complete')
		// console.log('onload - responseText: ', req.responseText)
	};
	req.send();
}
function postUpdateSheet() {
	var req = startFunctionRequest("/postUpdateSheet");
	req.onload = function () {
		// console.log('API Request - postUpdateSheet: Complete')
		// console.log('onload - responseText: ', req.responseText)
	};
	req.send();
}
function postSignatoryStatus() {
	var req = startFunctionRequest("/postSignatoryStatus");
	req.onload = function () {
		// console.log('API Request - postSignatoryStatus: Complete')
		// console.log('onload - responseText: ', req.responseText)
	};
	req.send();
}
function postOnsipUsers() {
	var req = startFunctionRequest("/postOnsipUsers");
	req.onload = function () {
		// console.log("API Request - postOnsipUsers: Complete");
		// console.log("onload - responseText: ", req.responseText);
	};
	req.send();
}
function postSlackActiveUsers() {
	var req = startFunctionRequest("/postSlackActiveUsers");
	req.onload = function () {
		// console.log('API Request - postSlackActiveUsers: Complete')
		// console.log('onload - responseText: ', req.responseText)
	};
	req.send();
}
function updateSlackActiveUsersPublicChannels() {
	var req = startFunctionRequest("/updateSlackActiveUsersPublicChannels");
	req.onload = function () {
		// console.log('API Request - postSlackActiveUsers: Complete')
		// console.log('onload - responseText: ', req.responseText)
	};
	req.send();
}
function postDates() {
	var req = startFunctionRequest("/postDates");
	req.onload = function () {
		// console.log('API Request - setDate: Complete')
		// console.log('onload - responseText: ', req.responseText)
	};
	req.send();
}



/***/ }),

/***/ "CaBU":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* style the userImage to fit in nav */\n.update-text {\n  max-width: 600px;\n}\n", ""]);

// exports


/***/ }),

/***/ "CkWL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = ({
  authenticated: function authenticated(to, from, next) {
    //next(authenticated)
  },
  authorized: function authorized(to, from, next) {
    //next(authorized)
  }
});

/***/ }),

/***/ "CkpQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavItems_vue__ = __webpack_require__("g6/6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7385360d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavItems_vue__ = __webpack_require__("He5q");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("k+Zw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7385360d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavItems_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7385360d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavItems_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/NavItems.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7385360d", Component.options)
  } else {
    hotAPI.reload("data-v-7385360d", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DlZj":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.jglogo[data-v-b23842e2] {\n  fill: currentColor;\n}\npath[data-v-b23842e2] {\n  stroke: currentColor;\n}\n", ""]);

// exports


/***/ }),

/***/ "DvXg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Roles_vue__ = __webpack_require__("u6kN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_538ddd6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Roles_vue__ = __webpack_require__("5v62");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Roles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_538ddd6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Roles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Roles/Roles.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-538ddd6a", Component.options)
  } else {
    hotAPI.reload("data-v-538ddd6a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EREM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return auth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return signin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return signout; });
/* unused harmony export setAdministrator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store___ = __webpack_require__("IcnI");
/* eslint-disable no-undef */



// Firebase Config
var config = {
	apiKey: "AIzaSyDSfMn3bvOXIp3P4rMbB6_xoCo37q8MAkI",
	authDomain: "issy-development.firebaseapp.com",
	databaseURL: "https://issy-development.firebaseio.com",
	databasecloudfunctionsUrl: "https://us-central1-issy-development.cloudfunctions.net/app",
	projectId: "issy-development",
	storageBucket: "issy-development.appspot.com",
	messagingSenderId: "730362306977",
	appId: "1:730362306977:web:cc3802a6fa6d425b4dabe0",
	measurementId: "G-CMFL40VX5J"
};
// Initialize Firebase
__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(config);

// Firebase Auth Objects
var googleAuthProvider = new __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth.GoogleAuthProvider();
var auth = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth();

function signin() {
	return __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signInWithRedirect(googleAuthProvider).catch(function (error) {
		console.error("error.message :", error.message);
		console.error("error.code :", error.code);
		console.error("error.credential :", error.credential);
		console.error("error.email :", error.email);
	});
}

function signout() {
	var _this = this;

	return __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signOut().then(function () {
		_this.$router.push("/");
	});
}

function setAdministrator(user, administratorsEmail) {
	var payload = {
		user: user,
		administratorsEmail: administratorsEmail
	};
	this.$store.dispatch("SET_ADMINISTRATOR", payload);
}



/***/ }),

/***/ "F9Nl":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.user-name[data-v-7385360d]{\n  text-transform: capitalize;\n  font-size: 16px !important;\n}\n", ""]);

// exports


/***/ }),

/***/ "FNa+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store___ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_service_groups_js__ = __webpack_require__("R5Ho");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_service_selected_person__ = __webpack_require__("MsY1");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      searchGroup: "",
      searchEmail: "",
      headersGroup: [{ text: "Name", value: "name" }, { text: "Email", value: "email" }],
      headersPerson: [{ text: "First", value: "fName" }, { text: "Last", value: "lName" }, { text: "Email", value: "email" }]
    };
  },

  computed: {
    selectedGroupKey: function selectedGroupKey() {
      return this.$store.getters.selectedGroupKey;
    },
    selectedGroup: function selectedGroup() {
      return this.$store.getters.selectedGroup;
    },
    selectedGroupMembers: function selectedGroupMembers() {
      return this.$store.getters.selectedGroupMembers;
    },
    selectedMemberKey: function selectedMemberKey() {
      return this.$store.getters.selectedMemberKey;
    },
    selectedMember: function selectedMember() {
      return this.$store.getters.selectedMember;
    },
    selectedMemberships: function selectedMemberships() {
      return this.$store.getters.selectedMemberships;
    },
    activePersons: function activePersons() {
      var people = this.$store.getters.people;
      if (people === null) return [];
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(people).filter(function (key) {
        return people[key].active;
      }).map(function (key) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ key: key }, people[key]);
      });
    },
    groups: function groups() {
      var groups = this.$store.getters.groups;
      if (groups === null) return [];
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(groups).map(function (key) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ key: key }, groups[key]);
      });
    }
  },
  methods: {
    selectGroup: function selectGroup(key) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__vue_service_groups_js__["b" /* setSelectedGroup */])(key);
    },
    selectMember: function selectMember(key) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__vue_service_groups_js__["a" /* setSelectedMember */])(key);
    },
    selectMemberFromEmail: function selectMemberFromEmail(email) {
      var key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__vue_service_selected_person__["b" /* getPersonsPushId */])(email);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__vue_service_groups_js__["a" /* setSelectedMember */])(key);
    }
  }
});

/***/ }),

/***/ "Fxs+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-xs": "" } },
    [
      _c(
        "v-card",
        {},
        [
          _c(
            "v-card-title",
            { staticClass: "primary" },
            [
              _c(
                "v-icon",
                { staticClass: "icon-space white--text", attrs: { left: "" } },
                [_vm._v("assignment")]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "ml-4 headline white--text" }, [
                _vm._v("PROJECT MANAGEMENT OVERVIEW")
              ]),
              _c("span", { staticClass: "beta-text ml-3" }, [_vm._v("beta")]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: {
                  dark: "",
                  "append-icon": "search",
                  label: "Search",
                  "single-line": "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("v-data-table", {
            attrs: {
              headers: _vm.headersProjects,
              items: _vm.projectsManagementOverview,
              search: _vm.search,
              "rows-per-page-items": [8, 15, 25, { text: "All", value: -1 }],
              light: ""
            },
            scopedSlots: _vm._u([
              {
                key: "items",
                fn: function(props) {
                  return [
                    _c(
                      "tr",
                      {
                        on: {
                          click: function($event) {
                            _vm.setSelectedProject(props.item.id)
                            props.expanded = !props.expanded
                          }
                        }
                      },
                      [
                        _c(
                          "td",
                          [
                            props.item.updateStatus == "3 - green"
                              ? _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      large: "",
                                      color: "light-green darken-2"
                                    }
                                  },
                                  [_vm._v("star\n            ")]
                                )
                              : props.item.updateStatus == "2 - yellow"
                              ? _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      large: "",
                                      color: "amber darken-1"
                                    }
                                  },
                                  [_vm._v("info\n            ")]
                                )
                              : props.item.updateStatus == "1 - red"
                              ? _c(
                                  "v-icon",
                                  {
                                    attrs: { large: "", color: "red darken-2" }
                                  },
                                  [_vm._v("warning\n            ")]
                                )
                              : _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      large: "",
                                      color: "secondary darken-3"
                                    }
                                  },
                                  [_vm._v("help\n            ")]
                                )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(props.item.cName))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(props.item.name))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(props.item.leadName))])
                      ]
                    )
                  ]
                }
              },
              {
                key: "expand",
                fn: function(props) {
                  return [
                    _c("v-card", { attrs: { flat: "" } }, [_c("project")], 1)
                  ]
                }
              },
              {
                key: "pageText",
                fn: function(ref) {
                  var pageStart = ref.pageStart
                  var pageStop = ref.pageStop
                  return [
                    _vm._v(
                      "\n          From " +
                        _vm._s(pageStart) +
                        " to " +
                        _vm._s(pageStop) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cce41e2", esExports)
  }
}

/***/ }),

/***/ "GIPo":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("pWcd");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("9662a768", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2e395e08\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PeopleFilters.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2e395e08\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PeopleFilters.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "GZQa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_service_auth_js__ = __webpack_require__("EREM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__People_ThisMonth_vue__ = __webpack_require__("/QVs");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    "this-month": __WEBPACK_IMPORTED_MODULE_1__People_ThisMonth_vue__["a" /* default */]
  },
  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    authenticated: function authenticated() {
      return this.$store.getters.authenticated;
    },
    authorized: function authorized() {
      return this.$store.getters.authorized;
    }
  },
  methods: {
    signin: __WEBPACK_IMPORTED_MODULE_0__vue_service_auth_js__["b" /* signin */],
    signout: __WEBPACK_IMPORTED_MODULE_0__vue_service_auth_js__["c" /* signout */]
  }
});

/***/ }),

/***/ "Gd8t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JG_Logo_vue__ = __webpack_require__("XlIx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b23842e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JG_Logo_vue__ = __webpack_require__("fOSX");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("psNk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b23842e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JG_Logo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b23842e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JG_Logo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/icons/JG_Logo.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b23842e2", Component.options)
  } else {
    hotAPI.reload("data-v-b23842e2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HOXW":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.sidebar[data-v-3570c818]{\n  position: fixed;\n  top: 64px !important;\n  left: 80px;\n  z-index: 9;\n  height: calc(100% - 64px) !important;\n}\n.sidebar-list[data-v-3570c818]{\n  padding-top: 0px;\n}\n.person-selector-container[data-v-3570c818]{\n  height: 100%;\n  width: 100%;\n  padding-bottom: 64px;\n  display: flex;\n  flex-direction: column;\n  overflow-y: scroll;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n.person-selector-container[data-v-3570c818]::-webkit-scrollbar {\n  display: none;\n}\n.person-image-holder[data-v-3570c818]{\n  padding: 0% 10%;\n  margin: 10px 0px;\n  display: flex;\n  align-content: center;\n}\n.person-image[data-v-3570c818]{\n  width: 100%;\n  border-radius: 50%;\n}\n.person[data-v-3570c818]{\n  cursor: pointer;\n}\n.selected-person[data-v-3570c818]{\n  background-color: rgb(218, 218, 218);\n}\n.temp-name-container[data-v-3570c818]{\n  position: relative;\n}\n.temp-name-text[data-v-3570c818]{\n  position:absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: white;\n}\n", ""]);

// exports


/***/ }),

/***/ "He5q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-toolbar-items",
    { staticClass: "hidden-xs-only" },
    [
      _c(
        "v-menu",
        {
          attrs: { "open-on-hover": "", bottom: "", "offset-y": "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: { text: "", to: "/people" },
                          on: { click: _vm.setUserAsSelected }
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c("img", {
                        staticClass: "toolbar-title-img ma-3",
                        attrs: { src: _vm.user.photoURL, alt: "user photo" }
                      }),
                      _vm._v(" "),
                      _c(
                        "v-list-item-title",
                        { staticClass: "primary--text user-name" },
                        [_vm._v(_vm._s(_vm.user.displayName))]
                      ),
                      _vm._v(" "),
                      _c("v-icon", { staticClass: "primary--text" }, [
                        _vm._v("keyboard_arrow_down")
                      ])
                    ],
                    1
                  )
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _c(
            "v-list",
            _vm._l(_vm.vertItems, function(item, index) {
              return _c(
                "v-list-item",
                { key: index, on: { click: _vm.signout } },
                [_c("v-list-item-title", [_vm._v(_vm._s(item.title))])],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7385360d", esExports)
  }
}

/***/ }),

/***/ "IDfc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_People_vue__ = __webpack_require__("4q66");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71fef2af_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_People_vue__ = __webpack_require__("UZoC");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("9y5z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71fef2af"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_People_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71fef2af_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_People_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/People/People.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-71fef2af", Component.options)
  } else {
    hotAPI.reload("data-v-71fef2af", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IaSg":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("paoq");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("000b874d", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-54f74f74\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LandingPage.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-54f74f74\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LandingPage.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__("ukYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("mUbh");






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({

	state: {
		// Is the user signed in with google
		authenticated: false,
		// Firebase user info (some)
		user: {
			email: null,
			displayName: null,
			photoURL: null
		},
		groups: null,
		// a group
		group: {
			name: null,
			email: null,
			members: null
		},
		// Is the user allowed into the app
		authorized: false,
		// Is the user in the database/administrator list
		administrator: false,
		token: null,
		// Which person has the user selected
		selectedPersonKey: null,
		selectedPersonVehicles: [],
		selectedPersonIsUser: false,
		selectedGroupKey: null,
		selectedGroup: {
			name: null,
			email: null,
			members: null
		},
		memberships: null,
		selectedGroupMembers: null,
		selectedMemberKey: null,
		selectedMember: null,
		selectedMemberships: null,
		selectedSlackMember: null,
		selectedSlackMemberships: null,
		// a person
		person: {
			// Contact
			active: null,
			email: null,
			fName: null,
			lName: null,
			nName: null,
			title: null,
			phone1: null,
			phone2: null,
			email1: null,
			email2: null,
			street: null,
			city: null,
			zip: null,
			// Emergency
			emergencyName: null,
			emergencyRelationship: null,
			emergencyPhone1: null,
			emergencyPhone2: null,
			// Vehicle
			vehicleMakeModel: null,
			licensePlateNumber: null,
			// Administration
			id: null,
			birthDate: null,
			startDate: null,
			status: null,
			group: null,
			shareBirthDate: null,
			kelmarId: null,
			teamPage: null,
			selectedProjectKey: null,
			onsipExtension: null
		},
		/*
   * vehicles[]
   *
   * color: string
   * licensePlateNumber: string
   * licensePlateState: string
   * make: string
   * model: string
   * userKey: string
   * vehicleKey: string
   */
		vehicles: [],
		/*
   * people[]
   *
   * active
   * activeClockify
   * activeSlack
   * activeToggl
   * birthDate
   * city
   * docusign
   * email
   * email1
   * email2
   * emergencyName
   * emergencyPhone1
   * emergencyPhone2
   * emergencyRelationship
   * fName
   * group
   * id
   * kelmarId
   * licensePlateNumber
   * lName
   * nName
   * onsipExtension
   * phone1
   * phone2
   * shareBirthDate
   * skills
   * startDate
   * status
   * street
   * teamPage
   * title
   * vehicleMakeModel
   * zip
   */
		people: null,
		/*
   * technology[]
   * 
   *	CanonicalUrl: string - stackshare url
   *	Category: string - Business Tools, DevOps, etc
   *	Core: true/false - is tech core to JG 
   *	Count: number
   *	Description: string - description of tech
   *	Id: sting - ??
   *	ImageUrl: string - image url
   *	Name: string - skill name
   *	OssRepo: string - ??
   *	Slug: string - for stackshare url ??
   *	Title: string - from stackshare ??
   *	WebsiteUrl: sting - website url
   */
		technology: [],
		// An object with person keys corresponding to the people with skills
		skillsRatingByTechnology: [],
		skillsRatingByPerson: null,
		// An object with skills keys corresponding to skills a person rated themselves on
		selectedPersonSkillsRating: null,
		// People with a birthday this month
		birthdaysThisMonth: null,
		anniversariesThisMonth: null,
		// TODO !! remove the stuff below here
		togglProjects: {
			billable: null,
			cName: null,
			name: null,
			cid: null,
			wid: null
		},
		projectsManagementOverview: {
			cName: null,
			name: null,
			leadName: null,
			updateStatus: null,
			updateTimestamp: null
		},
		projectsManagementDetails: {
			billable: null,
			cName: null,
			cid: null,
			id: null,
			leadName: null,
			name: null,
			updateStatus: null,
			updateText: null,
			updateTimestamp: null,
			wid: null
		},
		selectedProjectKey: null,
		project: {
			cName: null,
			name: null,
			lead: null,
			status: null,
			updated: null
		}
	},
	getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */],
	mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
	actions: __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "IlOy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PeopleFilters_vue__ = __webpack_require__("jcsV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e395e08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PeopleFilters_vue__ = __webpack_require__("BE4E");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("GIPo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e395e08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PeopleFilters_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e395e08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PeopleFilters_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/People/PeopleFilters.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2e395e08", Component.options)
  } else {
    hotAPI.reload("data-v-2e395e08", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JCWt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc198ee2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Accounts_vue__ = __webpack_require__("zdgG");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc198ee2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Accounts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Accounts/Accounts.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bc198ee2", Component.options)
  } else {
    hotAPI.reload("data-v-bc198ee2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JYT8":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("AQSN");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("7d8b4530", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e8e6a3ba\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PeopleNavigation.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e8e6a3ba\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PeopleNavigation.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "LLs5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export database */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return peopleRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return vehiclesRef; });
/* unused harmony export activePersonsRef */
/* unused harmony export inactivePersonsRef */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return groupsRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return membershipsRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return slackMembershipsRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return technologyRef; });
/* unused harmony export skillsMapRef */
/* unused harmony export togglProjectsRef */
/* unused harmony export projectsRef */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return projectsLeadsRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return projectManagementOverviewViewRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return projectManagementDetailsViewRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return projectsUpdatesRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return birthdaysThisMonthRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return anniversariesThisMonthRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return administratorsRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return usersRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return skillsRatingRef; });
/* unused harmony export skillsRatingByPersonRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);


var database = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database();
var peopleRef = database.ref("people");
var vehiclesRef = database.ref("vehicles");
var activePersonsRef = database.ref("activePersons");
var inactivePersonsRef = database.ref("inactivePersons");
var groupsRef = database.ref("groups");
var membershipsRef = database.ref("memberships");
var slackMembershipsRef = database.ref("slackMemberships");
var technologyRef = database.ref("technology");
var skillsMapRef = database.ref("skillsMap");
var togglProjectsRef = database.ref("togglProjects");
var projectsRef = database.ref("projects");
var projectsLeadsRef = database.ref("projectsLeads");
var projectManagementOverviewViewRef = database.ref("projectManagementOverviewView");
var projectManagementDetailsViewRef = database.ref("projectManagementDetailsView");
var projectsUpdatesRef = database.ref("projectsUpdates");
var birthdaysThisMonthRef = database.ref("birthdaysThisMonth");
var anniversariesThisMonthRef = database.ref("anniversariesThisMonth");
var administratorsRef = database.ref("administrators");
var usersRef = database.ref("users");

var skillsRatingRef = database.ref("skillsRating");
var skillsRatingByPersonRef = database.ref("skillsRating/byPerson");

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ba5bd90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Ty93");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("vax7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ba5bd90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/App.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7ba5bd90", Component.options)
  } else {
    hotAPI.reload("data-v-7ba5bd90", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mk/W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "person-page" },
    [
      _c("div", { staticClass: "person-header primary white--text" }, [
        _c("div", { staticClass: "person-name-container" }, [
          _c(
            "div",
            { staticClass: "edit-name-header" },
            [
              _c(
                "v-dialog",
                {
                  attrs: { "max-width": "500" },
                  model: {
                    value: _vm.dialog,
                    callback: function($$v) {
                      _vm.dialog = $$v
                    },
                    expression: "dialog"
                  }
                },
                [
                  _c(
                    "v-card",
                    [
                      _c("v-card-title", { staticClass: "headline" }, [
                        _vm._v("Continue with unsaved changes?")
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "\n              Are you sure you want to continue? Unsaved changes will be lost.\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "green darken-1", text: "" },
                              on: {
                                click: function($event) {
                                  return _vm.continueWithUnsavedChanges()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                Continue Anyways\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "red darken-1", text: "" },
                              on: {
                                click: function($event) {
                                  _vm.dialog = false
                                }
                              }
                            },
                            [_vm._v("\n                Cancel\n              ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              (_vm.userIsSelected || _vm.userIsAdmin) && !_vm.editingName
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "white", icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.changeEditing(_vm.startEditingName)
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("edit")])],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.editingName
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "white", outlined: "" },
                      on: {
                        click: function($event) {
                          return _vm.saveNameEdits()
                        }
                      }
                    },
                    [_vm._v("\n          Save\n        ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.editingName
                ? _c(
                    "v-btn",
                    {
                      style: { "margin-left": "20px" },
                      attrs: { color: "white", outlined: "" },
                      on: {
                        click: function($event) {
                          _vm.editingName = !_vm.editingName
                        }
                      }
                    },
                    [_vm._v("\n          Cancel\n        ")]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "span",
                { staticClass: "person-name" },
                [
                  !_vm.editingName
                    ? _c("span", [_vm._v(_vm._s(_vm.selectedPerson.fName))])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editingName
                    ? _c("v-text-field", {
                        staticClass: "name-edit-text-field",
                        attrs: { "hide-details": "", dark: "", dense: "" },
                        model: {
                          value: _vm.nameFields["fName"],
                          callback: function($$v) {
                            _vm.$set(_vm.nameFields, "fName", $$v)
                          },
                          expression: "nameFields['fName']"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(" "))]),
                  _vm._v(" "),
                  !_vm.editingName
                    ? _c("span", [_vm._v(_vm._s(_vm.selectedPerson.lName))])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editingName
                    ? _c("v-text-field", {
                        staticClass: "name-edit-text-field",
                        attrs: { "hide-details": "", dark: "", dense: "" },
                        model: {
                          value: _vm.nameFields["lName"],
                          callback: function($$v) {
                            _vm.$set(_vm.nameFields, "lName", $$v)
                          },
                          expression: "nameFields['lName']"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedPerson.nName
                    ? _c("span", [_vm._v(_vm._s(" ("))])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.editingName
                    ? _c("span", [_vm._v(_vm._s(_vm.selectedPerson.nName))])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editingName
                    ? _c("v-text-field", {
                        staticClass: "name-edit-text-field",
                        attrs: { "hide-details": "", dark: "", dense: "" },
                        model: {
                          value: _vm.nameFields["nName"],
                          callback: function($$v) {
                            _vm.$set(_vm.nameFields, "nName", $$v)
                          },
                          expression: "nameFields['nName']"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedPerson.nName
                    ? _c("span", [_vm._v(_vm._s(")"))])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              !_vm.editingName
                ? _c("span", [_vm._v(_vm._s(_vm.selectedPerson.group))])
                : _vm._e(),
              _vm._v(" "),
              _vm.editingName
                ? _c("v-text-field", {
                    staticClass: "name-edit-text-field",
                    attrs: { "hide-details": "", dark: "", dense: "" },
                    model: {
                      value: _vm.nameFields["group"],
                      callback: function($$v) {
                        _vm.$set(_vm.nameFields, "group", $$v)
                      },
                      expression: "nameFields['group']"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "profile-picture",
        attrs: { src: "https://cdn.vuetifyjs.com/images/cards/road.jpg" }
      }),
      _vm._v(" "),
      _c(
        "v-container",
        { staticClass: "user-info", attrs: { fluid: "", "grid-list-lg": "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs4: "" } },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-tabs",
                        {
                          staticClass: "tab-header",
                          attrs: {
                            color: "primary",
                            grow: "",
                            "slider-color": "primary"
                          },
                          model: {
                            value: _vm.currentItem,
                            callback: function($$v) {
                              _vm.currentItem = $$v
                            },
                            expression: "currentItem"
                          }
                        },
                        _vm._l(_vm.leftItems, function(item) {
                          return _c(
                            "v-tab",
                            { key: item, attrs: { href: "#tab-" + item } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item) +
                                  "\n            "
                              )
                            ]
                          )
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tabs-items",
                        {
                          model: {
                            value: _vm.currentItem,
                            callback: function($$v) {
                              _vm.currentItem = $$v
                            },
                            expression: "currentItem"
                          }
                        },
                        _vm._l(_vm.leftItems, function(item) {
                          return _c(
                            "v-tab-item",
                            {
                              key: item,
                              staticClass: "tab-page",
                              attrs: { value: "tab-" + item }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "edit-tab" },
                                [
                                  _vm.userIsAdmin && !_vm.editing[item]
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "primary", icon: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.changeEditing(
                                                _vm.startEditing,
                                                item
                                              )
                                            }
                                          }
                                        },
                                        [_c("v-icon", [_vm._v("edit")])],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.editing[item]
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "primary",
                                            outlined: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.saveEdits(item)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Save\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.editing[item]
                                    ? _c(
                                        "v-btn",
                                        {
                                          style: { "margin-left": "20px" },
                                          attrs: {
                                            color: "primary",
                                            outlined: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.editing[item] = !_vm.editing[
                                                item
                                              ]
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Cancel\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-card",
                                { attrs: { flat: "" } },
                                [
                                  _c(
                                    "v-card-text",
                                    _vm._l(
                                      _vm.scopedItems(_vm.leftLayout[item]),
                                      function(field) {
                                        return _c(
                                          "div",
                                          { key: field.label },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "field-label" },
                                              [_vm._v(_vm._s(field.label))]
                                            ),
                                            _vm._v(" "),
                                            !_vm.editing[item]
                                              ? _c(
                                                  "div",
                                                  { staticClass: "field-data" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.selectedPerson[
                                                          field.id
                                                        ]
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.editing[item]
                                              ? _c("v-text-field", {
                                                  attrs: { label: field.label },
                                                  model: {
                                                    value:
                                                      _vm.editedItems[item][
                                                        field.id
                                                      ],
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.editedItems[item],
                                                        field.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editedItems[item][field.id]"
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs4: "" } },
                [
                  _c(
                    "v-card",
                    [
                      _c("v-card-text", [
                        _c(
                          "div",
                          {
                            staticClass: "card-title flex-title primary--text"
                          },
                          [
                            _c("span", [_vm._v("Skills")]),
                            _vm._v(" "),
                            _vm.userIsSelected || _vm.userIsAdmin
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "primary--text",
                                    attrs: { to: "/skills", outlined: "" }
                                  },
                                  [_vm._v("Manage Skills")]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "card-subtitle primary--text" },
                          [_vm._v("Level 3: Lead/Teach")]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "unbulleted-list" },
                          _vm._l(_vm.selectedPersonSkillsRating3, function(
                            skill
                          ) {
                            return _c(
                              "li",
                              { key: skill.key, staticClass: "skill-li" },
                              [
                                skill.Name === "None"
                                  ? _c(
                                      "span",
                                      { staticClass: "no-skills-label" },
                                      [_vm._v("None")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                skill.Name !== "None"
                                  ? _c(
                                      "span",
                                      { staticClass: "skill-label" },
                                      [
                                        _c("v-img", {
                                          staticClass: "skill-image",
                                          attrs: {
                                            src: skill.ImageUrl,
                                            "max-width": "16pt"
                                          }
                                        }),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(skill.Name) +
                                            "\n                "
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                skill.Core === "TRUE"
                                  ? _c(
                                      "v-icon",
                                      {
                                        staticClass: "core-icon",
                                        attrs: { color: "primary" }
                                      },
                                      [_vm._v("$jglogo")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "card-subtitle primary--text" },
                          [_vm._v("Level 2: Confident/Experienced")]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "unbulleted-list" },
                          _vm._l(_vm.selectedPersonSkillsRating2, function(
                            skill
                          ) {
                            return _c(
                              "li",
                              { key: skill.key, staticClass: "skill-li" },
                              [
                                skill.Name === "None"
                                  ? _c(
                                      "span",
                                      { staticClass: "no-skills-label" },
                                      [_vm._v("None")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                skill.Name !== "None"
                                  ? _c(
                                      "span",
                                      { staticClass: "skill-label" },
                                      [
                                        _c("v-img", {
                                          staticClass: "skill-image",
                                          attrs: {
                                            src: skill.ImageUrl,
                                            "max-width": "16pt"
                                          }
                                        }),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(skill.Name) +
                                            "\n                "
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                skill.Core === "TRUE"
                                  ? _c(
                                      "v-icon",
                                      {
                                        staticClass: "core-icon",
                                        attrs: { color: "primary" }
                                      },
                                      [_vm._v("$jglogo")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35d18db8", esExports)
  }
}

/***/ }),

/***/ "MsY1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPersonsPushId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setUserAsSelectedPerson; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setSelected; });
/* unused harmony export setSelectedSlackMember */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_service_database__ = __webpack_require__("LLs5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_service_skills__ = __webpack_require__("xDPB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_service_groups__ = __webpack_require__("R5Ho");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store___ = __webpack_require__("IcnI");
/* unused harmony reexport setSelectedMember */






// Get the user's key from peopleRef, 
function personKeyPromise(user) {
	return __WEBPACK_IMPORTED_MODULE_1__vue_service_database__["c" /* peopleRef */].orderByChild("email").equalTo(user.email).once("value", function (peopleData) {
		peopleData.forEach(function (snapshot) {
			return snapshot.key;
		});
	});
}
// Get person's key from their email
function getPersonsPushId(email) {
	var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_4__store___["a" /* default */].getters.people).filter(function (key) {
		return __WEBPACK_IMPORTED_MODULE_4__store___["a" /* default */].getters.people[key].email == email;
	});
	return key.toString();
}
function setUserAsSelectedPerson(user) {
	return personKeyPromise(user).then(function (userKeyData) {
		var userKeyObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(userKeyData.val());
		var userKey = userKeyObject[0];
		// Bad Side Effect ??
		setSelected(userKey);
	});
}
function setSelectedPerson(key) {
	return __WEBPACK_IMPORTED_MODULE_1__vue_service_database__["c" /* peopleRef */].child(key).once("value").then(function (snapshot) {
		var person = snapshot.val();
		__WEBPACK_IMPORTED_MODULE_4__store___["a" /* default */].dispatch("SET_SELECTED_PERSON_KEY", key);
		__WEBPACK_IMPORTED_MODULE_4__store___["a" /* default */].dispatch("SET_PERSON", person);
		__WEBPACK_IMPORTED_MODULE_4__store___["a" /* default */].dispatch("SET_SELECTED_PERSON_IS_USER", key);
	});
}
function setSelectedSlackMember(key) {
	__WEBPACK_IMPORTED_MODULE_1__vue_service_database__["j" /* slackMembershipsRef */].child(key).once("value").then(function (snapshot) {
		var slackMembershipData = snapshot.val();
		if (slackMembershipData.memberships) {
			var slackMemberships = slackMembershipData.memberships;
			var slackMembershipNames = slackMemberships.map(function (selectedSlackMember) {
				return { title: selectedSlackMember.name };
			});
			// store.dispatch("SET_SELECTED_SLACK_MEMBER", slackMembershipData.email);
			__WEBPACK_IMPORTED_MODULE_4__store___["a" /* default */].dispatch("SET_SELECTED_SLACK_MEMBERSHIPS", slackMemberships);
		}
		// store.dispatch("SET_SELECTED_MEMBER_KEY", key);
	});
}
function setSelectedVehicles(key) {
	return __WEBPACK_IMPORTED_MODULE_1__vue_service_database__["k" /* vehiclesRef */].once("value").then(function (snapshot) {
		var vehiclesData = snapshot.val();
		var selectedPersonVehicles = {};
		for (var vehicle in vehiclesData) {
			if (vehiclesData[vehicle].userKey == key) {
				selectedPersonVehicles[vehicle] = vehiclesData[vehicle];
			}
		}
		if (selectedPersonVehicles) {
			__WEBPACK_IMPORTED_MODULE_4__store___["a" /* default */].dispatch("SET_SELECTED_PERSON_VEHICLES", selectedPersonVehicles);
		}
	});
}
/*
 * Updates who the selected person is
 * in the store (globally)
 * 
 * the key is a person's push ID
 */
function setSelected(key) {
	setSelectedPerson(key);
	// TODO - If there are no memberships (such as after creating a new person) selectedMember will be incorrect
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__vue_service_groups__["a" /* setSelectedMember */])(key);
	setSelectedVehicles(key);
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__vue_service_skills__["a" /* setSelectedPersonSkillsRating */])(key);
}



/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuefire__ = __webpack_require__("1mcD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__node_modules_vuetify_dist_vuetify_min_css__ = __webpack_require__("7zck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__node_modules_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__node_modules_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router___ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store___ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_json_excel__ = __webpack_require__("fXhN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__icons_JG_Logo_vue__ = __webpack_require__("Gd8t");












__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuetify___default.a);
var opts = {
	dark: false,
	theme: {
		themes: {
			light: {
				primary: "#1198aa",
				secondary: "#f2f2f2",
				accent: "#8c9eff",
				error: "#b71c1c",
				chart0: "#1198aa",
				chart1: "#88CCD5",
				chart2: "#D14B26",
				chart3: "#E8A593",
				chart4: "#09BC03",
				chart5: "#84DE81"
			}
		}

	},
	icons: {
		values: {
			jglogo: {
				component: __WEBPACK_IMPORTED_MODULE_10__icons_JG_Logo_vue__["a" /* default */]
			}
		}
	}
};

// Connect to Firebase DB with VueFire
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuefire___default.a);
var database = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.database();

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component("downloadExcel", __WEBPACK_IMPORTED_MODULE_9_vue_json_excel__["a" /* default */]); // Kill this

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
	el: "#app",
	router: __WEBPACK_IMPORTED_MODULE_7__router___["a" /* default */],
	store: __WEBPACK_IMPORTED_MODULE_8__store___["a" /* default */],
	template: "<App/>",
	components: {
		App: __WEBPACK_IMPORTED_MODULE_6__App__["a" /* default */]
	},
	firebase: {
		database: database.ref()
	},
	vuetify: new __WEBPACK_IMPORTED_MODULE_4_vuetify___default.a(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, opts))
});

/***/ }),

/***/ "NPRX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PeopleNavigation_vue__ = __webpack_require__("XyA+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8e6a3ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PeopleNavigation_vue__ = __webpack_require__("BsXh");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("JYT8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e8e6a3ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PeopleNavigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8e6a3ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PeopleNavigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/People/PeopleNavigation.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e8e6a3ba", Component.options)
  } else {
    hotAPI.reload("data-v-e8e6a3ba", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ohp0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resetPersonForm */
/* unused harmony export savePersonFromForm */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addNewPerson; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_service_database__ = __webpack_require__("LLs5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_service_api__ = __webpack_require__("CBkA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_service_skills__ = __webpack_require__("xDPB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store___ = __webpack_require__("IcnI");






function addNewPerson(newEmail, newFirstName, newLastName, skills) {
	var newPerson = {
		email: newEmail,
		fName: newFirstName,
		lName: newLastName
	};

	// Update Firebase with newPerson
	var newPersonRef = __WEBPACK_IMPORTED_MODULE_1__vue_service_database__["c" /* peopleRef */].push();
	console.log("newPushKey", newPersonRef.key);
	newPersonRef.set(newPerson);
	// Update Store with newPerson
	var person = void 0;
	__WEBPACK_IMPORTED_MODULE_1__vue_service_database__["c" /* peopleRef */].child(newPersonRef.key).once("value").then(function (snapshot) {
		person = snapshot.val();
		__WEBPACK_IMPORTED_MODULE_4__store___["a" /* default */].dispatch("SET_SELECTED_PERSON_KEY", newPersonRef.key);
		__WEBPACK_IMPORTED_MODULE_4__store___["a" /* default */].dispatch("SET_PERSON", person);
	});

	// Update skills of new person
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__vue_service_skills__["b" /* updatePersonSkillsRating */])(newPersonRef.key, skills);
}
function resetPersonForm() {
	var _this = this;

	var selectedPersonKey = this.$store.getters.selectedPersonKey;
	__WEBPACK_IMPORTED_MODULE_1__vue_service_database__["c" /* peopleRef */].child(selectedPersonKey).once("value").then(function (snapshot) {
		_this.$store.dispatch("SET_PERSON", snapshot.val());
	});
}
function savePersonFromForm() {
	var selectedPersonKey = this.$store.getters.selectedPersonKey;
	var person = this.$store.getters.person;
	// This process removes keys if they are not require, e.g., undefined
	__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(person).forEach(function (selectedPersonKey) {
		return person[selectedPersonKey] == null && delete person[selectedPersonKey];
	});
	return __WEBPACK_IMPORTED_MODULE_1__vue_service_database__["c" /* peopleRef */].child(selectedPersonKey).update(person).then(function () {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__vue_service_api__["c" /* updatePersonsGSuiteStatus */])();
	});
}


/***/ }),

/***/ "OyH4":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.icon-space[data-v-ea413962] {\n  margin-right: 10px;\n  margin-bottom: 0px;\n  padding-right: 10px;\n  padding-bottom: 0px;\n}\n.v-input--selection-controls.v-input .v-label[data-v-ea413962] {\n  display: none;\n}\ntable.v-table tbody td[data-v-ea413962]:first-child,\ntable.v-table tbody td[data-v-ea413962]:not(:first-child),\ntable.v-table tbody th[data-v-ea413962]:first-child,\ntable.v-table tbody th[data-v-ea413962]:not(:first-child),\ntable.v-table thead td[data-v-ea413962]:first-child,\ntable.v-table thead td[data-v-ea413962]:not(:first-child),\ntable.v-table thead th[data-v-ea413962]:first-child,\ntable.v-table thead th[data-v-ea413962]:not(:first-child) {\n  padding: 0 1rem;\n  border: 1px;\n}\n.v-input__slot[data-v-ea413962] {\n  margin-bottom: 0;\n}\n.filter-bar[data-v-ea413962] {\n  display: flex;\n  justify-content: left;\n  align-items: center;\n}\n.filter-item + .filter-item[data-v-ea413962] {\n  margin-left: 10px;\n}\n.tooltip-header[data-v-ea413962] {\n  padding: 20px;\n  margin: -20px;\n}\n", ""]);

// exports


/***/ }),

/***/ "P0G/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_service_database__ = __webpack_require__("LLs5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Project_vue__ = __webpack_require__("sLfu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store___ = __webpack_require__("IcnI");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    project: __WEBPACK_IMPORTED_MODULE_2__Project_vue__["a" /* default */]
  },
  firebase: {
    projects: __WEBPACK_IMPORTED_MODULE_1__vue_service_database__["l" /* projectManagementOverviewViewRef */]
  },
  computed: {
    projectsTableExport: function projectsTableExport() {
      var exportObject = {};
      for (var i; i < this.projects.length; i++) {
        console.log("this.projects:", this.projects[i]);
        exportObject[i] = this.projects[i];
      }
      return exportObject;
    },
    projectsManagementOverview: function projectsManagementOverview() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.$store.getters.projectsManagementOverview);
    },
    selectedProjectKey: function selectedProjectKey() {
      return this.$store.getters.selectedProjectKey;
    },
    projectsManagementDetails: function projectsManagementDetails() {
      return this.$store.getters.projectsManagementDetails;
    },
    projectStatusIsGreen: function projectStatusIsGreen() {
      var project = this.$store.getters.project;
      if (project.updateStatus == "3 - green") {
        return true;
      }
      return false;
    },
    projectStatusIsYellow: function projectStatusIsYellow() {
      var project = this.$store.getters.project;
      if (project.updateStatus == "2 - yellow") {
        return true;
      }
      return false;
    },
    projectStatusIsRed: function projectStatusIsRed() {
      var project = this.$store.getters.project;
      if (project.updateStatus == "1 - red") {
        return true;
      }
      return false;
    }
  },
  methods: {
    setSelectedProject: function setSelectedProject(key) {
      var _this = this;

      /*
        / key is returned from v-data-table <tr> @click=" ... "
        / key is dispatched to store.setSelecdtedProjectKey
        / Let's use this project to find a project in projectsRef
        */
      console.log("setSelectedProject KEY", key);
      __WEBPACK_IMPORTED_MODULE_1__vue_service_database__["m" /* projectManagementDetailsViewRef */].child(key).once("value", function (snapshot) {
        var project = snapshot.val();
        console.log("project", project);
        _this.$store.dispatch("SET_SELECTED_PROJECT_KEY", key);
        _this.$store.dispatch("SET_PROJECT", project);
        return project;
      });
    }
  },
  data: function data() {
    return {
      tmp: "",
      search: "",
      pagination: {},
      headersProjects: [{
        text: "Status",
        align: "left",
        sortable: true,
        value: "updateStatus"
      }, {
        text: "Client",
        align: "left",
        sortable: true,
        value: "cName"
      }, {
        text: "Project",
        align: "left",
        sortable: true,
        value: "name"
      }, {
        text: "Lead",
        align: "left",
        sortable: true,
        value: "leadName"
      }],
      tempData: [{
        updatedOn: "01/01/2018",
        updateDetails: "Here are some details regarding the projects status, a Yellow warning",
        status: "Yellow"
      }, {
        updatedOn: "01/04/2018",
        updateDetails: "The latest update - Fake details regarding the projects status. Fake updates ready for Prod v1.5.2.",
        status: "Green"
      }]
    };
  },

  created: function created() {
    /*
        / If the selectedProjectKey is null, then
        / Update Store selectedProjectKey to first project in PMO
        */
    if (!this.$store.getters.selectedProjectKey) {
      var self = this;
      var key = this.$store.getters.projectsManagementOverview[0].id;
      this.$store.dispatch("SET_SELECTED_PROJECT_KEY", key);
      console.log("this.$store.getters.projectsManagementDetails[0]", this.$store.getters.projectsManagementDetails[0]);
      self.setSelectedProject(key);
    }
  }
});

/***/ }),

/***/ "P87o":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("m02A");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("2cc157cd", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5164f0e6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AddPerson.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5164f0e6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AddPerson.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "R5Ho":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setSelectedGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setSelectedMember; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");


function setSelectedGroup(key) {
  var selectedGroup = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.groups[key];
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch("SET_SELECTED_GROUP_KEY", key);
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch("SET_SELECTED_GROUP", selectedGroup);
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch("SET_SELECTED_GROUP_MEMBERS", selectedGroup.members);
}

function setSelectedMember(key) {
  var membershipData = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.memberships[key];
  if (membershipData) {
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch("SET_SELECTED_MEMBER_KEY", key);
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch("SET_SELECTED_MEMBER", membershipData.email);
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch("SET_SELECTED_MEMBERSHIPS", membershipData.memberships);
  }
}



/***/ }),

/***/ "SF+z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "text-align": "center" } },
    [
      !_vm.user || !_vm.user.displayName
        ? _c("v-container", [
            !_vm.user || !_vm.user.displayName
              ? _c(
                  "div",
                  { staticClass: "title primary--text darken-1--text" },
                  [_vm._v("\n      Click the Sign-in button to Login\n  ")]
                )
              : _vm._e()
          ])
        : _c(
            "v-container",
            [
              _vm.user && !_vm.authorized
                ? _c(
                    "div",
                    [
                      _c(
                        "div",
                        { staticClass: "title primary--text darken-1--text" },
                        [
                          _vm._v(
                            "\n            Please use your Jahnel Group email address to sign in.\n            "
                          ),
                          _c("br"),
                          _c("br")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          staticStyle: { cursor: "pointer" },
                          attrs: { to: "/LandingPage", tag: "span" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "primary darken-2",
                              on: { click: _vm.signout }
                            },
                            [
                              _vm._v(
                                "\n            Switch Accounts\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.authorized ? _c("this-month") : _vm._e()
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54f74f74", esExports)
  }
}

/***/ }),

/***/ "SnSb":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("nqH1");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("580fe128", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-35d18db8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PersonPage.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-35d18db8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PersonPage.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "TrJJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.userIsAdmin
        ? _c(
            "v-btn",
            {
              staticClass: "add-person-button",
              attrs: { color: "primary", outlined: "", light: "" },
              nativeOn: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.addPersonOpen = !_vm.addPersonOpen
                }
              }
            },
            [_vm._v("\n      Add Person\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "" },
          model: {
            value: _vm.addPersonOpen,
            callback: function($$v) {
              _vm.addPersonOpen = $$v
            },
            expression: "addPersonOpen"
          }
        },
        [
          _c(
            "v-form",
            {
              ref: "addPersonForm",
              model: {
                value: _vm.addPersonFormIsValid,
                callback: function($$v) {
                  _vm.addPersonFormIsValid = $$v
                },
                expression: "addPersonFormIsValid"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", { staticClass: "headline" }, [
                    _vm._v("Add New Person?")
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { "px-3": "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "E-mail",
                          rules: _vm.validationRules.emailRequiredValidUnique,
                          required: ""
                        },
                        on: { blur: _vm.emailIsUnique },
                        model: {
                          value: _vm.newEmail,
                          callback: function($$v) {
                            _vm.newEmail = $$v
                          },
                          expression: "newEmail"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: {
                          label: "First Name",
                          rules: _vm.validationRules.nameRequiredValid,
                          counter: 15,
                          required: ""
                        },
                        model: {
                          value: _vm.newFirstName,
                          callback: function($$v) {
                            _vm.newFirstName = $$v
                          },
                          expression: "newFirstName"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: {
                          label: "Last Name",
                          rules: _vm.validationRules.nameRequiredValid,
                          counter: 15,
                          required: ""
                        },
                        model: {
                          value: _vm.newLastName,
                          callback: function($$v) {
                            _vm.newLastName = $$v
                          },
                          expression: "newLastName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-flex",
                        { attrs: { "p-6": "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { disabled: !_vm.addPersonFormIsValid },
                              on: {
                                click: function($event) {
                                  return _vm.addPerson(
                                    _vm.newEmail,
                                    _vm.newFirstName,
                                    _vm.newLastName
                                  )
                                }
                              }
                            },
                            [_vm._v("Add")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              on: {
                                click: function($event) {
                                  _vm.clearAddDialogFields()
                                  _vm.addPersonOpen = false
                                }
                              }
                            },
                            [_vm._v("Cancel")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5164f0e6", esExports)
  }
}

/***/ }),

/***/ "Ty93":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c("nav-gation"),
      _vm._v(" "),
      _c(
        "v-content",
        { staticClass: "secondary main-viewport" },
        [
          _c(
            "v-container",
            { staticClass: "secondary", attrs: { fluid: "" } },
            [_c("router-view")],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}

/***/ }),

/***/ "UZoC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("people-nav", {
        attrs: { "viewing-profile": _vm.viewingProfile },
        on: {
          updatedSearchTerm: _vm.handleSearch,
          backToMainPeoplePage: _vm.handleBack
        }
      }),
      _vm._v(" "),
      _vm.viewingProfile
        ? _c("person-selector", {
            attrs: { people: _vm.filteredPeople },
            on: { selectPerson: _vm.selectPerson }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "person-content" }, [
        _vm.viewingProfile
          ? _c("div", { staticClass: "person-display" }, [_c("person-page")], 1)
          : _vm._e(),
        _vm._v(" "),
        !_vm.viewingProfile
          ? _c(
              "div",
              [
                _c("people-filters", {
                  on: {
                    changeFilter: _vm.handleChangeFilter,
                    showInactive: _vm.handleShowInactive
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "people-cards" },
                  _vm._l(_vm.filteredPeople, function(p) {
                    return _c(
                      "div",
                      {
                        key: p.fName + p.lName,
                        staticClass: "person-card",
                        on: {
                          click: function($event) {
                            return _vm.selectPerson(p)
                          }
                        }
                      },
                      [
                        _c("v-card", { attrs: { color: "white" } }, [
                          _c("div", { staticClass: "person-image-holder" }, [
                            _c("img", {
                              staticClass: "person-image",
                              attrs: {
                                src:
                                  "https://cdn.vuetifyjs.com/images/cards/road.jpg"
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "person-card-content person-name" },
                            [_vm._v(_vm._s(p.fName + " " + p.lName))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "person-card-content person-job" },
                            [_vm._v(_vm._s(p.group))]
                          )
                        ])
                      ],
                      1
                    )
                  }),
                  0
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71fef2af", esExports)
  }
}

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import { retry } from "rxjs/operator/retry";

/* harmony default export */ __webpack_exports__["a"] = ({
	authenticated: function authenticated(state) {
		return state.authenticated;
	},
	user: function user(state) {
		return state.user;
	},
	authorized: function authorized(state) {
		return state.authorized;
	},
	administrator: function administrator(state) {
		return state.administrator;
	},
	token: function token(state) {
		return state.token;
	},
	selectedPersonKey: function selectedPersonKey(state) {
		return state.selectedPersonKey;
	},
	selectedPersonVehicles: function selectedPersonVehicles(state) {
		return state.selectedPersonVehicles;
	},
	selectedPersonIsUser: function selectedPersonIsUser(state) {
		return state.selectedPersonIsUser;
	},
	people: function people(state) {
		return state.people;
	},
	technology: function technology(state) {
		return state.technology;
	},
	skillsRatingByTechnology: function skillsRatingByTechnology(state) {
		return state.skillsRatingByTechnology;
	},
	person: function person(state) {
		return state.person;
	},
	selectedGroupKey: function selectedGroupKey(state) {
		return state.selectedGroupKey;
	},
	groups: function groups(state) {
		return state.groups;
	},
	selectedGroup: function selectedGroup(state) {
		return state.selectedGroup;
	},
	memberships: function memberships(state) {
		return state.memberships;
	},
	selectedGroupMembers: function selectedGroupMembers(state) {
		return state.selectedGroupMembers;
	},
	selectedMemberKey: function selectedMemberKey(state) {
		return state.selectedMemberKey;
	},
	selectedMember: function selectedMember(state) {
		return state.selectedMember;
	},
	selectedMemberships: function selectedMemberships(state) {
		return state.selectedMemberships;
	},
	selectedSlackMember: function selectedSlackMember(state) {
		return state.selectedSlackMember;
	},
	selectedSlackMemberships: function selectedSlackMemberships(state) {
		return state.selectedSlackMemberships;
	},
	birthdaysThisMonth: function birthdaysThisMonth(state) {
		return state.birthdaysThisMonth;
	},
	anniversariesThisMonth: function anniversariesThisMonth(state) {
		return state.anniversariesThisMonth;
	},
	togglProjects: function togglProjects(state) {
		return state.togglProjects;
	},
	projectsManagementOverview: function projectsManagementOverview(state) {
		return state.projectsManagementOverview;
	},
	projectsManagementDetails: function projectsManagementDetails(state) {
		return state.projectsManagementDetails;
	},
	selectedProjectKey: function selectedProjectKey(state) {
		return state.selectedProjectKey;
	},
	project: function project(state) {
		return state.project;
	},
	skillsRatingByPerson: function skillsRatingByPerson(state) {
		return state.skillsRatingByPerson;
	},
	selectedPersonSkillsRating: function selectedPersonSkillsRating(state) {
		return state.selectedPersonSkillsRating;
	}
});

/***/ }),

/***/ "VZjw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-navigation-drawer",
    {
      staticClass: "primary sidebar",
      attrs: {
        fixed: "",
        permanent: "",
        "mini-variant": true,
        "mini-variant-width": 80
      }
    },
    [
      _vm.authorized
        ? _c(
            "v-list",
            { staticClass: "sidebar-list", attrs: { "two-line": "" } },
            _vm._l(_vm.filteredMenuItems, function(item) {
              return _c(
                "v-list-item",
                {
                  key: item.title,
                  class: [
                    _vm.$route.path.includes(item.link) ? "selected" : "",
                    "list-item"
                  ],
                  attrs: { to: item.link }
                },
                [
                  _c(
                    "v-list-item-action",
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { right: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "v-icon",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass:
                                              "white--text link-icon",
                                            attrs: { large: "" }
                                          },
                                          "v-icon",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [_vm._v(_vm._s(item.icon))]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" "), _c("span", [_vm._v(_vm._s(item.title))])]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c5cc5f4", esExports)
  }
}

/***/ }),

/***/ "W7WA":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgAAZABkAAD/7AARRHVja3kAAQAEAAAAMQAA/+4ADkFkb2JlAGTAAAAAAf/bAIQACAYGBgYGCAYGCAwIBwgMDgsICAsOEA0NDg0NEBEMDg4ODgwREBMUFRQTEBkZGxsZGSUkJCQlKSkpKSkpKSkpKQEJCAgJCgkLCgoLDgwODA4SDg4ODhIUDg4PDg4UGhIQEBAQEhoXGBUVFRgXHBwaGhwcIyMiIyMpKSkpKSkpKSkp/8AAEQgAZABkAwEiAAIRAQMRAf/EAJsAAQADAQEBAQEAAAAAAAAAAAAFBgcEAQgDAgEAAgMBAQAAAAAAAAAAAAAAAAMBAgQFBhAAAgEDAgMGAggEBQUAAAAAAQIDAAQFEQYhMRJBUWEiEwdCFHGBkaHRMiMVscFiFuGCkrIzUnJDJDQRAAICAQMDAgUBCQAAAAAAAAECAAMRITEEQVESYYHwcZEiBROhscHR8TJCUmL/2gAMAwEAAhEDEQA/AN/pSlEIpSlEIpXPc3tpaDW4lVO5SdW/0jjUXNuezQ6RRvJ48FH31Uuo3Ijq+PdZqlbEd+n1k5Sq+N1Q6+a2YDwYH+Qrtt89jbjQGT0mPZINB/q5VAsQ7MJZ+HyEGWrb21/dJOleKwYBlIIPIjiK9q8zxSlKIRSlKIRSlKITwkAEk6AcSTVaym4mJaDHnRRwaftP/b+NNxZQljj4G0Vf+dh2n/o/Gq9We2058V9zOvweCviLbRnOqqdsdzPWZ5GLMSzNzJ4kmuyHEZKcAx27aHkW0X/dpX7YS+gs7r/2EUpJoPVI1ZD3g93fV0BBGo4g8jVa6wwyT7R3M5tlDBFrGCNGOx9hKU2AyqjX0NfoZSf41wzW1xbN0zxNGezqBGv0VodfzJHHMhjlUOh5qw1FXNA6E+8yp+WsB+9FI/50P8ZRbLJXdgwML6p8UTcVP1Vb8dk4MjF1R+WRf+SI8x+IqEy+A9FWurEExji8PMqO9fCoW2uZbSZZ4W0dT9RHcfCqBmrOG2+Nppspo5lf6lWA/fY57NNCpXPZXcd7bJcR8mHFe0MOYrorUDkZE4jKVJVhgg4IilKUSIrnvbkWlpLcH/xqSo72PBR9tYl72b03VtbdWHj2/fywRNaieS0UBo5HSZ9etdNSCq6Hjyrl3L7iX+4M7sm4wd9LbYrMLGL/AB6sCBMs/pzRScNeHLxGhFQ2xx2l6gDYgbYsAflmXlmaRyzEs7HUntJNXGzw0CY35WddXmAaVu0N2aH+msItspvHfO9L7b+1ckmGs8Wzg3HTqzGJugsx0Zj1MDoBoNKt3tlvXdLbsynt9vKZL2+x6u9vfoAC3plQVYqq9QZXDKSAe/wVVXjJbXM6HO5hYqleVCnOdsldBj5SfvrKawuGglHLijdjL3iprAZfTpsLluHKBz/sP8qrfvhkr7EbK/cMZO1tdrdwos8fBgrhupde46Vk+6s9uu3xm0RjL+eG9yVgZrkqelpXAVutuHE6a1ArKOCp0Ms3Lr5HHZbUJZQNR/sTgET6hpXzZuf3N3Xf7c2yMFkJLe/XHzXmYniKgyCJlg1bhz6o3P11eMzvjI4T2Wx+eku2bN5K2hgt7ptOszzal5OXNY1Zh4inA5nLZSpwZrdU3PY8WV31xDSGfVlHYG+JaqHtLufdA3FmNmb2unuMpDDDd2pkIJCMis6AgDXyyo2n01WbzdO9/cbLZ58Nl4cBtvb7avK+inoLPHHJI/SWJb02Y8Qqj762IGX5dZp4fIam0EAkNoVHXtNd2zdmO5e0Y+WUdSD+pfxFWqvnfF53ctntnPSXedsb/IWNs81heWE6S3CaagmQIoGnLQnj31VcVv8Az93aCbJ+4N3jrksQbb5WSfRRybrj0HGoqyAQehl+f4tYtigjzXJB7jSfWVKg9Lv+z+n9xPzv7bp+7dB19X0P/q9Pn+bz9NKZMUo++dobizHuVtXP46z9bF470RfT+pGvQBOzuCjsGbyHsBqjZv2ly+3PcG0y+EthJts3kVyjCRF+XBfqkh6GYMQmnl0B8unbrX0bUbnrcz42XTi0Wkg/y8/uJqr58TjtG8cKbqw2g8hMLg23vja28rzcOw4bbIJky5eyuGVekyH1HBDyRcm4qQ3hVv8AbTYG5MfuTJ763o8a5jIqyR2kTKwQSMrOzFNVGgQKoBPCpS2ma2uIp15xsG079DyrQY5EljWWM6o4DKfA8apS/kCDuJq/I8cVOrLnxbPsdzKF7w7czO6dnnF4K2+avPmoZfS60j8iB+o9UrKvb31UslsLdd0/twVx4dcDapFlyZYdYun0gU4v5+CH8utbZSmkZmFWKkEdDn6T5asvbrP4+PdUTWpLyQNZ4ZDInnR7gSNpq3k8qfFpzqfyux93bxx2zdsW0HymMw1rGmUu2khYxXEmgkf0hIrSdCp5env51s+fxHqqb62X9ReMyD4gPiHiKrlrdS2c63EJ0dfsI7QfA0g2MjYbadVOLTyKPKokMBsTsd8GUdfbLfu1t9YXc9jezboCOBkbqZ0imWE/oyRn5mdi/wCkx6dDXPmvb7fOzMhuB9q21tltt7gBW7s5nCMqOzMqMGkibVOtlVkbke/lvNjew39us8XDsdO1W7jUPui6Ajis1PmY+o/0Dgv20xmAQtvpMNFDNyFqIKkN93cY3mEbf9vM7Y4vcLSQwJf5ize1ssXbv1BWdgygyyMVHEaAdR8TUhtjAe721sUmJttm4q8iR3cT3ht5ZiXOpBdbpeA7OFalgoDPkoeHlj1kb/Ly+/SrtVaiWBJ7x35CtKnStM6Lk59TIb1c7/anr/Jw/wBwft/X+36j0PnfQ19DXr06PV8v5+XbSpmlNmGK8YBgVYagjQjwNe0ohKHkrFrC7eE/kPmibvU8vs5VKYDLrDpY3LaRk/oueSk/CfCpvJ46LIwem3lkXjFJ3H8DVKubaa0laGdSrr9hHePCsrA1t5Db40ncpsr5lH6Vn94GvfI/yE0KlU3H567sgIn/AFoRyVj5gPBqm4dx42QD1GaI9oZSfvXWnLah64+c593A5FZ0UuOhXX9kl6quexHy7G9tl/RY/qIPgJ7foNTLZ3FKNfX18ArH+VR15uaFkaO1h9TqBBaX8uh/pHOosNZXBI9MS/Dr5ddoZK2wdGDDxBHvIXHZCXHT+rH5kbhJHroGH+Ffjc3El3O9xMdXc6nuA7APor8jxOtTmFwrXDLd3a6QDiiH4/p/p/jWdQzYUbTr2tTT5XsAGIxnqfSSW3rA21sbiQaSz6EDtCDl9vOpmlK2KoUADpPO3WtbY1jbsf6CKUpUxcUpSiEVz3dlbXsfp3CBh8LcmH0GuilBAOhkqxUhlJBGxEqt3tm5jJa0cSr2K3lb8DUVNYXkB0lgdfqJH2ir/SkmhTtpOhX+UuUYcB/XYzOxDMx0WNie4Ka7bfB5K40Ii9NT8Uh6R9nP7qu9KgUDqSZZ/wAtYR9tar6k+X8pDWG3ra2IkuD68o4gEaID9Hb9dTNKU5VCjAGJgtustbysYsfjYRSlKmLilKUQilKUQilKUQilKUQilKUQilKUQilKUQilKUQn/9k="

/***/ }),

/***/ "XkyN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return emailIsUnique; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validationRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store___ = __webpack_require__("IcnI");


function emailIsUnique(newEmail) {
	// TODO: Micheal Shirk says to...
	// TODO: UPDATE to use .every() instead of for() loop below
	// console.log("store.getters.people", store.getters.people)
	// console.log("bool:", [...store.getters.people].every(person => person.email != newEmail))
	// return [...store.getters.people].every(person => person.email != newEmail)

	// TODO: UPDATE to remove for() loop
	var isUnique = void 0;
	for (var person in __WEBPACK_IMPORTED_MODULE_0__store___["a" /* default */].getters.people) {
		isUnique = __WEBPACK_IMPORTED_MODULE_0__store___["a" /* default */].getters.people[person].email !== newEmail;
		if (!isUnique) {
			return isUnique;
		}
	}
	return isUnique;
}
// function fieldIsNull(field) {
// 	return !!field || field;
// }
var validationRules = {
	nameValid: [function (v) {
		return v && v.length <= 35 || "Name must be less than 35 characters";
	}],
	nameRequiredValid: [function (v) {
		return !!v || "Name is required";
	}, function (v) {
		return v && v.length <= 35 || "Name must be less than 35 characters";
	}],
	fullNameRequiredValid: [function (v) {
		return !!v || "First and Last Name are required";
	}, function (v) {
		return (/^(.*\s+.*)+$/.test(v) || "First and Last Name are required"
		);
	}],
	emailValid: [function (v) {
		return (/((^$|^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$)?)/.test(v) || "E-mail must be valid"
		);
	}],
	emailRequiredValid: [function (v) {
		return !!v || "E-mail is required";
	}, function (v) {
		return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail must be valid"
		);
	}],
	emailRequiredValidUnique: [function (v) {
		return !!v || "E-mail is required";
	}, function (v) {
		return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail must be valid"
		);
	}, function (v) {
		return emailIsUnique(v) || "Email already exists";
	}],
	phoneValid: [function (v) {
		return (/((^$|([(][0-9]{3}[)] [0-9]{3}-[0-9]{4}))?)/.test(v) || "Phone must be valid. Example format: (555) 555-5555"
		);
	}],
	phoneRequiredValid: [function (v) {
		return !!v || "Phone Number is required";
	}, function (v) {
		return (/[(][0-9]{3}[)] [0-9]{3}-[0-9]{4}/.test(v) || "Phone must be valid. Example format: (555) 555-5555"
		);
	}],
	streetRequiredValid: [function (v) {
		return !!v || "Street is required";
	}, function (v) {
		return v && v.length <= 35 || "Street must be less than 35 characters";
	}],
	cityRequiredValid: [function (v) {
		return !!v || "Street is required";
	}, function (v) {
		return v && v.length <= 35 || "City must be less than 35 characters";
	}],
	zipRequiredValid: [
	// v => !!v || "Street is required",
	function (v) {
		return (/^(\d{5})?$/.test(v) || "Zip must be valid."
		);
	}],
	relationshipRequiredValid: [function (v) {
		return !!v || "Relationship is required";
	}, function (v) {
		return v && v.length <= 35 || "Relationship must be less than 35 characters";
	}],
	idRequiredValid: [function (v) {
		return !!v || "ID is required";
	}, function (v) {
		return v && v.length == 3 || "ID must be 3 digits. Example: 023";
	}, function (v) {
		return (/\d{3}/.test(v) || "ID must be 3 digits. Example: 023"
		);
	}],
	dateValid: [function (v) {
		return (/^$|(^((0|1)\d{1})[/]((0|1|2|3)\d{1})[/]((19|20)\d{2}))/.test(v) || "Use the following date format. 09/23/1970"
		);
	}],
	dateRequiredValid: [function (v) {
		return !!v || "Date is required";
	},
	// v => (v && v.length == 3) || "ID must be 3 digits. Example: 023",
	function (v) {
		return (/^((0|1)\d{1})[/]((0|1|2|3)\d{1})[/]((19|20)\d{2})/.test(v) || "Use the following date format. 09/23/1970"
		);
	}]
};


/***/ }),

/***/ "XlIx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "JGLogoIcon"
});

/***/ }),

/***/ "XyA+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },
  methods: {
    onInput: function onInput(input) {
      this.$emit("updatedSearchTerm", input);
    },
    handleClick: function handleClick() {
      if (this.viewingProfile) {
        this.$emit("backToMainPeoplePage");
      }
    }
  },
  props: ['viewingProfile']
});

/***/ }),

/***/ "YY3s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_service_skills__ = __webpack_require__("xDPB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vue_service_selected_person__ = __webpack_require__("MsY1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var defaultImg = __webpack_require__("W7WA");
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      noImg: defaultImg,
      editing: false,
      skillEdits: {},
      skillInterest: {},
      expanded: [],
      search: "",
      setSearch: true,
      categoryFilter: [],
      proficiencyFilter: [],
      coreFilter: false,
      personEmail: { email: this.$store.getters.person.email },
      proficiencies: [{ key: -1, value: "--:Not Rated" }, { key: 0, value: "0:Nothing/Novice" }, { key: 1, value: "1:Lacking/Inexperienced" }, { key: 2, value: "2:Confident/Experienced" }, { key: 3, value: "3:Lead/Teach" }],
      headers: [{
        text: "",
        value: "Image",
        width: "5%",
        filterable: false,
        sortable: false
      }, {
        text: "Category",
        value: "Category",
        width: "10%",
        filterable: false
      }, { text: "Skill", value: "Name", width: "10%", filterable: true }, {
        text: "JG Core Competency",
        value: "Core",
        width: "5%",
        filterable: false,
        align: "center"
      }, {
        text: "Interested",
        value: "Interested",
        width: "5%",
        filterable: false,
        align: "center"
      }, {
        text: "0",
        value: "0Rating",
        width: "5%",
        filterable: false,
        sortable: false,
        align: "center"
      }, {
        text: "1",
        value: "1Rating",
        width: "5%",
        filterable: false,
        sortable: false,
        align: "center"
      }, {
        text: "2",
        value: "2Rating",
        width: "5%",
        filterable: false,
        sortable: false,
        align: "center"
      }, {
        text: "3",
        value: "3Rating",
        width: "5%",
        filterable: false,
        sortable: false,
        align: "center"
      }, {
        text: "People Ranked",
        value: "Count",
        width: "5%",
        filterable: false,
        align: "center"
      }, { text: "Website", value: "WebsiteUrl", filterable: false }]
    };
  },

  computed: {
    userIsAdmin: function userIsAdmin() {
      return this.$store.getters.administrator;
    },
    userIsSelected: function userIsSelected() {
      return this.$store.getters.selectedPersonIsUser;
    },

    // Get tech skills ratings for everything before applying filters
    getAllTechSkillsRatings: function getAllTechSkillsRatings() {
      // Get all of the technologies we know about
      var technologies = this.$store.getters.technology;
      // Get all of the skills the selected person has rated themselves on
      var ratedSkills = this.$store.getters.selectedPersonSkillsRating;
      if (ratedSkills === null) {
        ratedSkills = {};
      }

      // Create an array that contains all of these skills and their keys, but rated
      var skills = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(technologies).map(function (key) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({
          key: key,
          rating: ratedSkills[key] ? ratedSkills[key].Rating : -1,
          interested: ratedSkills[key] ? ratedSkills[key].Interested ? true : false : false,
          changelog: ratedSkills[key] ? ratedSkills[key].Changelog ? ratedSkills[key].Changelog : null : null
        }, technologies[key]);
      });

      return skills;
    },
    updateTechs: function updateTechs() {
      updateTechnology();
    },

    // Apply filters to the rated skills
    getTechSkillsRatings: function getTechSkillsRatings() {
      var _this = this;

      // Get all skills
      var skills = this.getAllTechSkillsRatings;

      // If we aren't editing, hide unrated skills to keep things clean
      if (!this.editing) {
        skills = skills.filter(function (skill) {
          return skill.rating !== undefined && (skill.rating > -1 || skill.interested);
        });
      }
      // Apply filters
      if (this.categoryFilter.length !== 0) {
        skills = skills.filter(function (skill) {
          return _this.categoryFilter.includes(skill.Category);
        });
      }
      if (this.proficiencyFilter.length !== 0) {
        skills = skills.filter(function (skill) {
          return _this.proficiencyFilter.includes(skill.rating);
        });
      }
      if (this.coreFilter) {
        skills = skills.filter(function (skill) {
          return skill.Core === "TRUE";
        });
      }

      return skills;
    },
    getPpl: function getPpl() {
      var _this2 = this;

      // if the store is not ready, lets get a snapshot for now.
      // const testStore = true;
      // if (testStore){
      if (this.$store.getters.people === null) {
        if (this.personEmail.email === null) {
          this.personEmail = { email: this.$store.getters.person.email };
        }
        var snapShotArray = [];
        var database = __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.database();
        var peopleRef = database.ref("people").orderByChild("fName");
        peopleRef.once('value', function (snapShot) {
          snapShot.forEach(function (item) {
            var val = item.val();
            if (val.active) {
              snapShotArray.push(val);
            }
          });
        });
        // console.log("snapShotArray = \n"+JSON.stringify(snapShotArray.map(i=>i.fName+" "+i.lName)));
        return snapShotArray.map(function (item) {
          var i = item;
          // console.log("Skills.vue, ln 369\ngetPpl\n"+ item.fName+" "+item.lName);
          if (item.email === _this2.$store.getters.user.email) i = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, i, { lName: item.lName + " (me)" });
          return i;
        });
      } else {

        // TODO: This is sorta hacky, there must be a better way
        if (this.personEmail.email === null) {
          this.personEmail = { email: this.$store.getters.person.email };
        }
        var storeValues = [];
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.$store.getters.people).filter(function (item) {
          return item !== null && item.email && item.lName && item.active;
        }).map(function (item) {
          var i = item;
          // console.log("Skills.vue, ln 369\ngetPpl\n"+ item.fName+" "+item.lName);
          if (item.email === _this2.$store.getters.user.email) i = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, i, { lName: item.lName + " (me)" });
          return i;
        }).forEach(function (item) {
          storeValues.push(item);
        });
        var sorted = storeValues.sort(function (a, b) {
          return a.fName + a.lName > b.fName + b.lName ? 1 : -1;
        });
        // for (const item of sorted) {
        //   console.log("Skills.vue, ln 412\ngetPpl (sorted)\n"+ item.fName+" "+item.lName)
        // }
        return sorted;
      }
    },
    categories: function categories() {
      var tech = this.$store.getters.technology;
      if (tech === null) {
        return [];
      } else {
        return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(tech).map(function (e) {
          return e.Category;
        }))));
      }
    }
  },
  methods: {
    getName: function getName(item) {
      return item.fName + " " + item.lName;
    },
    changeSelectedPerson: function changeSelectedPerson(email) {
      var key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__vue_service_selected_person__["b" /* getPersonsPushId */])(email);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__vue_service_selected_person__["c" /* setSelected */])(key);
    },
    clearFilter: function clearFilter() {
      this.categoryFilter = [];
      this.proficiencyFilter = [];
      this.coreFilter = false;
    },
    clearSearch: function clearSearch() {
      this.search = "";
    },
    enableEditing: function enableEditing() {
      this.editing = true;

      // Setup skill edits with all tech skills in case some filters are active when user starts editing
      this.skillEdits = this.getAllTechSkillsRatings.reduce(function (acc, skill) {
        acc[skill.key] = {
          rating: skill.rating,
          interested: skill.interested,
          changelog: skill.changelog
        };
        return acc;
      }, {});
    },
    saveSkills: function saveSkills() {
      var _this3 = this;

      var oldSkills = this.$store.getters.selectedPersonSkillsRating;
      var techs = this.$store.getters.technology;

      // Filter out skills that have never been rated
      // Reduce current and updated skills to ratings and interest
      var skillsUpdates = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.skillEdits).filter(function (key) {
        return _this3.skillEdits[key].rating > 0 || _this3.skillEdits[key].interested || _this3.skillEdits[key].changelog !== null;
      }).reduce(function (acc, key) {
        // Get the rating and interest from skillEdits
        acc[key] = {
          Rating: _this3.skillEdits[key].rating,
          Interested: _this3.skillEdits[key].interested
        };

        // Apply all current data from the tech
        var tech = techs[key];
        for (var k in tech) {
          acc[key][k] = tech[k];
        }

        if (oldSkills[key] !== undefined) {
          // If skill was previously rated, get its changelog
          if (oldSkills[key].Changelog !== undefined) {
            // If there are old changelogs, process them to accountSkills for legacy storage and use them
            acc[key].Changelog = _this3.processOldChangelog(oldSkills[key].Changelog);
          } else {
            // Legacy - skill was rated before we were logging, so register its current rating with time 0
            acc[key].Changelog = {
              "0": {
                Rating: oldSkills[key].Rating,
                Interested: oldSkills[key].Interested ? true : false
              }
            };
          }
        } else {
          // Otherwise, make a new one (we'll add the new timestamp in the next part)
          acc[key].Changelog = {};
        }
        return acc;
      }, {});

      var timestamp = Date.now().toString();

      // Add new timestamp if something was changed
      for (var key in skillsUpdates) {
        var mostRecentChangeKey = this.getMostRecentKey(skillsUpdates[key]);
        if (mostRecentChangeKey === "-1") {
          // No history in changelog, new rating. Update changelog
          skillsUpdates[key].Changelog[timestamp] = {
            Rating: skillsUpdates[key].Rating,
            Interested: skillsUpdates[key].Interested
          };
        } else {
          // History in changelog, must check if new change is different
          var currentState = skillsUpdates[key].Changelog[mostRecentChangeKey];
          if (currentState.Rating !== skillsUpdates[key].Rating || currentState.Interested !== skillsUpdates[key].Interested) {
            // New change is different. Update changelog
            skillsUpdates[key].Changelog[timestamp] = {
              Rating: skillsUpdates[key].Rating,
              Interested: skillsUpdates[key].Interested
            };
          }
        }
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__vue_service_skills__["c" /* updateSelectedPersonSkillsRating */])(skillsUpdates);
      this.editing = false;
    },
    processOldChangelog: function processOldChangelog(changelog) {
      var cl = {};
      for (var key in changelog) {
        if (changelog[key].Interested === undefined) {
          // If changelog entry existed, but wasn't the new spec, update it
          cl[key] = { Rating: changelog[key], Interested: false };
        } else {
          // Otherwise, it was the new spec, keep it
          cl[key] = changelog[key];
        }
      }
      return cl;
    },
    getMostRecentKey: function getMostRecentKey(skill) {
      var mostRecent = "-1";
      for (var key in skill.Changelog) {
        if (parseInt(key) > parseInt(mostRecent)) {
          mostRecent = key;
        }
      }
      return mostRecent;
    }
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LandingPage__ = __webpack_require__("wSyU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Accounts_Accounts__ = __webpack_require__("JCWt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_People_People__ = __webpack_require__("IDfc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Skills_Skills__ = __webpack_require__("4HDL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Groups_Groups__ = __webpack_require__("b4bE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Projects_Projects__ = __webpack_require__("zqmC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Roles_Roles__ = __webpack_require__("DvXg");










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	routes: [{
		path: "/",
		name: "Root",
		component: __WEBPACK_IMPORTED_MODULE_2__components_LandingPage__["a" /* default */]
	}, {
		path: "/LandingPage",
		name: "LandingPage",
		component: __WEBPACK_IMPORTED_MODULE_2__components_LandingPage__["a" /* default */]
	}, {
		path: "/skills",
		name: "Skills",
		component: __WEBPACK_IMPORTED_MODULE_5__components_Skills_Skills__["a" /* default */]
	}, {
		path: "/accounts",
		name: "Accounts",
		component: __WEBPACK_IMPORTED_MODULE_3__components_Accounts_Accounts__["a" /* default */]
	}, {
		path: "/people",
		name: "People",
		component: __WEBPACK_IMPORTED_MODULE_4__components_People_People__["a" /* default */]
	}, {
		path: "/groups",
		name: "Groups",
		component: __WEBPACK_IMPORTED_MODULE_6__components_Groups_Groups__["a" /* default */]
	}, {
		path: "/projects",
		name: "Projects",
		component: __WEBPACK_IMPORTED_MODULE_7__components_Projects_Projects__["a" /* default */]
	}, {
		path: "/roles",
		name: "Roles",
		component: __WEBPACK_IMPORTED_MODULE_8__components_Roles_Roles__["a" /* default */]
	}],
	mode: "history"
}));

/***/ }),

/***/ "ZW1X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-content",
    [
      _c(
        "v-card",
        { staticClass: "primary lighten-1 white--text" },
        [
          _c(
            "v-container",
            { attrs: { fluid: "", "grid-list-sm": "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md4: "" } },
                    [
                      _c(
                        "v-toolbar",
                        {
                          staticClass: "subheading white--text",
                          class: _vm.statusStyle,
                          attrs: { dense: "" }
                        },
                        [
                          _c("v-icon", { staticClass: "white--text" }, [
                            _vm._v("comment")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml-3" }, [
                            _vm._v(_vm._s(_vm.project.updateTimestamp))
                          ]),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          !_vm.editUpdateOpen
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    right: "",
                                    flat: "",
                                    round: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.editUpdateOpen = true
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", { staticClass: "white--text" }, [
                                    _vm._v("add")
                                  ])
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.editUpdateOpen
                        ? _c(
                            "v-list",
                            {
                              staticClass: "primary lighten-1 white--text",
                              attrs: { "two-line": "" }
                            },
                            [
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          "\n                Update\n              "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-item-sub-title",
                                        { staticClass: "update-text" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.project.updateText) +
                                              "                                            \n              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.editUpdateOpen
                        ? _c(
                            "v-card",
                            [
                              _c(
                                "v-card-text",
                                [
                                  _vm._v(
                                    "\n            New Update Date: " +
                                      _vm._s(_vm.todaysDate) +
                                      "\n            "
                                  ),
                                  _c(
                                    "v-form",
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.projectStatuses,
                                          label: "New Project Update Status",
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.project.updateStatus,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.project,
                                              "updateStatus",
                                              $$v
                                            )
                                          },
                                          expression: "project.updateStatus"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "New Project Update Text",
                                      "multi-line": ""
                                    },
                                    model: {
                                      value: _vm.project.updateText,
                                      callback: function($$v) {
                                        _vm.$set(_vm.project, "updateText", $$v)
                                      },
                                      expression: "project.updateText"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "v-card-actions",
                                    [
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "hidden-xs-only",
                                          attrs: { flat: "" },
                                          on: {
                                            click: function($event) {
                                              _vm.editUpdateOpen = false
                                            }
                                          }
                                        },
                                        [_vm._v("Cancel\n              ")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "hidden-xs-only",
                                          attrs: { flat: "" },
                                          on: {
                                            click: function($event) {
                                              _vm.pushProjectUpdate()
                                              _vm.editUpdateOpen = false
                                            }
                                          }
                                        },
                                        [_vm._v("Save\n              ")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md4: "" } },
                    [
                      _c(
                        "v-toolbar",
                        {
                          staticClass: " subheading",
                          class: _vm.statusStyle,
                          attrs: { dense: "" }
                        },
                        [
                          _c("v-icon", { staticClass: "white--text" }, [
                            _vm._v("business")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml-3" }),
                          _vm._v(" "),
                          _c("v-spacer")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list",
                        {
                          staticClass: "primary lighten-1 white--text",
                          attrs: { "three-line": "" }
                        },
                        [
                          _c(
                            "v-list-item",
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "title" },
                                    [
                                      _vm._v(
                                        "\n                          " +
                                          _vm._s(_vm.project.cName) +
                                          "\n                      "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "subtitle" },
                                    [
                                      _vm._v(
                                        "\n                          " +
                                          _vm._s(_vm.project.name) +
                                          "\n                      "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-list-item-sub-title", [
                                    _vm._v(
                                      "\n                          Toggl Client ID: " +
                                        _vm._s(_vm.project.cid) +
                                        "                                            \n                      "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("v-list-item-sub-title", [
                                    _vm._v(
                                      "\n                          Toggl Project ID: " +
                                        _vm._s(_vm.project.id) +
                                        "                                            \n                      "
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md4: "" } },
                    [
                      _c(
                        "v-toolbar",
                        {
                          staticClass: " subheading",
                          class: _vm.statusStyle,
                          attrs: { dense: "" }
                        },
                        [
                          _c("v-icon", { staticClass: "white--text" }, [
                            _vm._v("account_box")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml-3" }),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          !_vm.editLeadOpen
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    small: "",
                                    icon: "",
                                    right: "",
                                    flat: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.editLeadOpen = true
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", { staticClass: "white--text" }, [
                                    _vm._v("mode_edit")
                                  ])
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.editLeadOpen
                        ? _c(
                            "v-list",
                            {
                              staticClass: "primary lighten-1 white--text",
                              attrs: { "one-line": "" }
                            },
                            [
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        { staticClass: "title" },
                                        [
                                          _vm._v(
                                            "\n                          " +
                                              _vm._s(_vm.project.leadName) +
                                              "\n                          "
                                          ),
                                          _c("v-list-item-action")
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.editLeadOpen
                        ? _c(
                            "v-card",
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-form",
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.peopleEmails,
                                          label: "Project Lead",
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.project.leadName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.project,
                                              "leadName",
                                              $$v
                                            )
                                          },
                                          expression: "project.leadName"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-card-actions",
                                [
                                  _c("v-spacer"),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "hidden-xs-only",
                                      attrs: { flat: "" },
                                      on: {
                                        click: function($event) {
                                          _vm.editLeadOpen = false
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      Cancel\n                      "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "hidden-xs-only",
                                      attrs: { flat: "", disabled: false },
                                      on: {
                                        click: function($event) {
                                          _vm.updateProjectLead()
                                          _vm.editLeadOpen = false
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      Save\n                      "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { xs12: "", md4: "" } })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41bd5494", esExports)
  }
}

/***/ }),

/***/ "b4bE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Groups_vue__ = __webpack_require__("FNa+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_befa09e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Groups_vue__ = __webpack_require__("5VcY");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("r+dV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-befa09e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Groups_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_befa09e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Groups_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Groups/Groups.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-befa09e2", Component.options)
  } else {
    hotAPI.reload("data-v-befa09e2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bVQ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_service_auth_js__ = __webpack_require__("EREM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavItems__ = __webpack_require__("CkpQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NavDrawer__ = __webpack_require__("nNMv");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    "nav-items": __WEBPACK_IMPORTED_MODULE_1__NavItems__["a" /* default */],
    "nav-drawer": __WEBPACK_IMPORTED_MODULE_2__NavDrawer__["a" /* default */]
  },
  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    authorized: function authorized() {
      return this.$store.getters.authorized;
    }
  },
  methods: {
    signin: __WEBPACK_IMPORTED_MODULE_0__vue_service_auth_js__["b" /* signin */]
  }
});

/***/ }),

/***/ "biUW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-nav" },
    [
      _c(
        "v-toolbar",
        { staticClass: "white primary--text", attrs: { fixed: "" } },
        [
          _c(
            "v-toolbar-title",
            [
              _c(
                "router-link",
                {
                  staticClass: "logo",
                  staticStyle: { cursor: "pointer" },
                  attrs: { to: "/LandingPage", tag: "span" }
                },
                [_vm._v("ISSY")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _vm.authorized ? _c("nav-items") : _vm._e(),
          _vm._v(" "),
          !_vm.user || !_vm.user.displayName
            ? _c(
                "v-btn",
                {
                  staticClass: "hidden-xs-only primary darken-2",
                  attrs: { to: "/LandingPage" },
                  on: { click: _vm.signin }
                },
                [_vm._v("\n      Sign in\n    ")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("nav-drawer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-81440b78", esExports)
  }
}

/***/ }),

/***/ "bwGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__("bVQ/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81440b78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__("biUW");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("69nz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-81440b78"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81440b78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Navigation.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-81440b78", Component.options)
  } else {
    hotAPI.reload("data-v-81440b78", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fOSX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "25",
        viewBox: "0 0 24 25"
      }
    },
    [
      _c(
        "g",
        {
          attrs: {
            id: "Layer_2",
            "data-name": "Layer 2",
            transform: "translate(0)"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Logo_Mark",
                "data-name": "Logo Mark",
                transform: "translate(0 0)"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "Logo_mark-2",
                    "data-name": "Logo mark",
                    transform: "translate(0 0)"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      id: "Path_2178",
                      "data-name": "Path 2178",
                      d:
                        "M11.99,0a12,12,0,1,0,12,12,12,12,0,0,0-12-12ZM7.89,9.319H9.616v2.122c-2.414,0-2.96,0-3.325.935H4.151A3.473,3.473,0,0,1,7.89,9.319Zm4.558,4.987c0,2.5-1.885,3.39-4.056,3.39-2.738,0-4.31-1.18-4.31-4.618H6.2c-.037,2.414,1.012,2.768,2.193,2.768a1.8,1.8,0,0,0,1.942-1.924v-8.8h2.114Zm4.134,3.308c-1.326.038-.983.024-1.292.024V15.6c1.307,0,2.8-.018,2.8-2.09s-1.391-2.072-2.8-2.072-2.131-.01-2.131-.01V9.319s2.072.01,3.425.01c1.332,0,3.522.9,3.522,4.181S17.9,17.58,16.582,17.614Z",
                      transform: "translate(0.01 0.4)",
                      fill: "#19a"
                    }
                  })
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b23842e2", esExports)
  }
}

/***/ }),

/***/ "fXhN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_JsonExcel_vue__ = __webpack_require__("uZUK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb865680_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_JsonExcel_vue__ = __webpack_require__("6CNk");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_JsonExcel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb865680_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_JsonExcel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue-json-excel/JsonExcel.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-fb865680", Component.options)
  } else {
    hotAPI.reload("data-v-fb865680", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g3Mq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("canvas", { attrs: { id: "project-chart" } })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58849936", esExports)
  }
}

/***/ }),

/***/ "g6/6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_service_auth__ = __webpack_require__("EREM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_service_selected_person__ = __webpack_require__("MsY1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "navitems",
  methods: {
    signout: __WEBPACK_IMPORTED_MODULE_0__vue_service_auth__["c" /* signout */],
    setUserAsSelected: function setUserAsSelected() {
      ;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__vue_service_selected_person__["a" /* setUserAsSelectedPerson */])(this.user);
    }
  },
  data: function data() {
    return {
      vertItems: [{ title: "Logout" }]
    };
  },
  computed: {
    user: function user() {
      return this.$store.getters.user;
    }
  }
});

/***/ }),

/***/ "h8tr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updatePersonInfo; });
/* unused harmony export addFullName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_service_database_js__ = __webpack_require__("LLs5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_service_selected_person_js__ = __webpack_require__("MsY1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");





function updatePersonInfo(email, allInfo) {
	var id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__vue_service_selected_person_js__["b" /* getPersonsPushId */])(email);
	__WEBPACK_IMPORTED_MODULE_1__vue_service_database_js__["c" /* peopleRef */].child(id).set(allInfo);
	__WEBPACK_IMPORTED_MODULE_1__vue_service_database_js__["c" /* peopleRef */].child(id).once("value", function (snapshot) {
		var updatedPerson = snapshot.val();
		var updatedPeople = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.people);
		updatedPeople[id] = updatedPerson;
		__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch("SET_PEOPLE", updatedPeople);
	});
}
// example function for updating data client-side...
// function addFullName(email) {
// 	let id = getPersonsPushId(email);
// 	let personRef = peopleRef.child(id);
// 	var name = "";
// 	personRef.once("value", item => {
// 		let i = item.val();
// 		name = i.fName.toLowerCase() + i.lName.toLowerCase();
// 	});
// 	personRef.update({
// 		"fullName": name
// 	});
// }



/***/ }),

/***/ "hIHY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PersonPage_vue__ = __webpack_require__("6p4m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35d18db8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PersonPage_vue__ = __webpack_require__("Mk/W");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("SnSb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35d18db8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PersonPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35d18db8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PersonPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/People/PersonPage.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-35d18db8", Component.options)
  } else {
    hotAPI.reload("data-v-35d18db8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i6U6":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n#project-chart[data-v-58849936]{\n  height: 100px;\n}\n", ""]);

// exports


/***/ }),

/***/ "jcsV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AddPerson_vue__ = __webpack_require__("xD1W");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    "add-person": __WEBPACK_IMPORTED_MODULE_1__AddPerson_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showInactive: false,
      role: [],
      workLocation: [],
      projectAllocation: [],
      sideHustle: [],
      employmentType: []
    };
  },

  computed: {
    roleCategories: function roleCategories() {
      // If the people array is null (such as during load) return an empty array of categories
      if (this.$store.getters.people === null) return [];

      // Extract all categories from the people
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.$store.getters.people).reduce(function (acc, person) {
        if (person.group && !acc.includes(person.group)) {
          acc.push(person.group);
        }
        return acc;
      }, []);
    },
    workLocationCategories: function workLocationCategories() {
      // Not defined yet in people
      return [];
    },
    projectAllocationCategories: function projectAllocationCategories() {
      // Not defined yet in people
      return [];
    },
    sideHustleCategories: function sideHustleCategories() {
      // Not defined yet in people
      return [];
    },
    employmentTypeCategories: function employmentTypeCategories() {
      // If the people array is null (such as during load) return an empty array of categories
      if (this.$store.getters.people === null) return [];

      // Extract all categories from the people
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.$store.getters.people).reduce(function (acc, person) {
        if (person.status) {
          // TODO - Statuses are not at all uniform. It would probably be better to clean this up in firebase
          var status = person.status.substring(0, 1).toUpperCase() + person.status.substring(1).toLowerCase();
          if (!acc.includes(status)) {
            acc.push(status);
          }
        }
        return acc;
      }, []);
    }
  },
  methods: {
    onFilter: function onFilter(id, value) {
      this.$emit("changeFilter", id, value);
    },
    onChangeInactive: function onChangeInactive() {
      this.$emit("showInactive", this.showInactive);
    },
    clearFilters: function clearFilters() {
      this.role = [];
      this.workLocation = [];
      this.projectAllocation = [];
      this.sideHustle = [];
      this.employmentType = [];
      this.showInactive = false;
      this.$emit("changeFilter", "clearAll", null);
      this.$emit("showInactive", false);
    }
  }
});

/***/ }),

/***/ "jjyn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectChart_vue__ = __webpack_require__("5l9i");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58849936_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectChart_vue__ = __webpack_require__("g3Mq");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("s/sK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58849936"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58849936_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/People/ProjectChart.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-58849936", Component.options)
  } else {
    hotAPI.reload("data-v-58849936", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k+Zw":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("F9Nl");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("513753c0", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7385360d\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NavItems.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7385360d\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NavItems.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "m02A":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.add-person-button{\n  margin-left: 10px;\n}\n.icon-space {\n  margin-right: 10px;\n  margin-bottom: 0px;\n  padding-right: 10px;\n  padding-bottom: 0px;\n}\n.edit-font {\n  font-size: 20px;\n}\n.secondary.v-card.v-sheet.theme--light {\n    flex: 1 1 auto!important;\n}\n", ""]);

// exports


/***/ }),

/***/ "mEcL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return findPeopleToLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fillPeopleRatedAt; });
/* unused harmony export erasePeopleRatedAt */
/* unused harmony export deleteSkillsRatingByPersonSkillNode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return findMissingTechProperties; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vue_service_database_js__ = __webpack_require__("LLs5");







// UTILITY FOR DB CLEANUP
var findPeopleToLog = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
		var peopleSnap, people, promises;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						console.log("looking");
						_context.next = 3;
						return __WEBPACK_IMPORTED_MODULE_6__vue_service_database_js__["c" /* peopleRef */].once("value").catch(function (err) {
							return console.log(err);
						});

					case 3:
						peopleSnap = _context.sent;
						people = peopleSnap.val();
						promises = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(people).map(function (key) {
							console.log("removeing from ", key);
							if (people[key].skills) {
								return __WEBPACK_IMPORTED_MODULE_6__vue_service_database_js__["c" /* peopleRef */].child(key).child("skills").set(null);
							}
						});
						return _context.abrupt("return", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(promises));

					case 7:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function findPeopleToLog() {
		return _ref.apply(this, arguments);
	};
}();

var erasePeopleRatedAt = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var skillsSnap, skills, promises;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.next = 2;
						return __WEBPACK_IMPORTED_MODULE_6__vue_service_database_js__["h" /* skillsRatingRef */].child("byTechnology").once("value");

					case 2:
						skillsSnap = _context2.sent;
						skills = skillsSnap.val();
						promises = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(skills).map(function (skill) {
							console.log("skill 0", skill);
							return __WEBPACK_IMPORTED_MODULE_6__vue_service_database_js__["h" /* skillsRatingRef */].child("byTechnology").child(skill).child("peopleRatedAt0").set(null);
						});
						return _context2.abrupt("return", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(promises));

					case 6:
					case "end":
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function erasePeopleRatedAt() {
		return _ref2.apply(this, arguments);
	};
}();

var findMissingTechProperties = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var peopleSnap, people, technologySnap, technology, missing, missingFromTech, peopleWithExtraTech, pK, sK;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						_context3.next = 2;
						return __WEBPACK_IMPORTED_MODULE_6__vue_service_database_js__["h" /* skillsRatingRef */].child("byPerson").once("value").catch(function (err) {
							return console.log(err);
						});

					case 2:
						peopleSnap = _context3.sent;
						people = peopleSnap.val();
						_context3.next = 6;
						return __WEBPACK_IMPORTED_MODULE_6__vue_service_database_js__["i" /* technologyRef */].once("value").catch(function (err) {
							return console.log(err);
						});

					case 6:
						technologySnap = _context3.sent;
						technology = technologySnap.val();
						//const peopleKeys = Object.keys(people);

						missing = [];
						missingFromTech = [];
						peopleWithExtraTech = [];
						// let loopCount = 0;

						for (pK in people) {
							for (sK in people[pK].skills) {
								// loopCount++;
								// if(loopCount>10) return true;
								// console.log("people[pK].skills[sK].Name", people[pK].skills[sK].Name);
								if (!(sK in technology)) {
									missingFromTech.push(sK);
									if (!(pK in peopleWithExtraTech)) peopleWithExtraTech[pK] = sK;
								}
								if (people[pK].skills[sK].Name === undefined) {
									missing.push({
										"pK": pK,
										"sK": sK,
										"Rating": people[pK].skills[sK].Rating
									});
								}
							}
						}
						// console.log("missing", missing);
						//console.log("missingFromTech", missingFromTech);
						console.log("peopleWithExtraTech", peopleWithExtraTech);
						return _context3.abrupt("return", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(missing).map(function (i) {
							if (i >= 0 || i <= 200) {
								var m = missing[i];
								var _pK = m.pK;
								var _sK = m.sK;
								var Rating = m.Rating;
								var techProperties = technology[_sK];
								var newSkillRating = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, techProperties, {
									Rating: Rating
								});
								// console.log("newSkillRating", newSkillRating);
								if (_sK == "-M1RA0615SJ-WLM9zJKv") {
									console.log("sK", _sK);
									return __WEBPACK_IMPORTED_MODULE_6__vue_service_database_js__["h" /* skillsRatingRef */].child("byPerson").child(_pK).child("skills").child(_sK).set(null);
								} else {
									return __WEBPACK_IMPORTED_MODULE_6__vue_service_database_js__["h" /* skillsRatingRef */].child("byPerson").child(_pK).child("skills").child(_sK).set(newSkillRating);
								}
							}
						})));

					case 14:
					case "end":
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function findMissingTechProperties() {
		return _ref3.apply(this, arguments);
	};
}();


function fillPeopleRatedAt() {
	var byPeople = store.getters.skillsRatingByPerson;
	var skillsRatingByTechnology = store.getters.skillsRatingByTechnology;
	//const technologies = store.getters.technology;
	var technologiesReduced = reduceTechnologies(skillsRatingByTechnology);
	var people = store.getters.people;
	var peopleReduced = reducePeople(people);

	// Loop through people to get their skill ratings
	// for each skill
	var countPeople = 0;
	for (var pKey in byPeople) {
		//if(pKey === "-L-hmPOjUimQaeTZDOh7") {
		if (true) {
			//console.log("pKey -LhmPOjUimQaeTZDOh7")
			countPeople++;
			//if(countPeople>15) return true;

			var byPerson = byPeople[pKey];
			var skills = byPerson.skills;
			var personReduced = peopleReduced[pKey];
			if (!(personReduced === undefined)) {
				// console.log("pKey", pKey)
				// console.log("byPeople", byPeople)

				// loop through skills byTechnology
				// and update peopleRatedAt
				var countSkills = 0;
				for (var sKey in skills) {
					countSkills++;
					//if(countSkills>300) return true;
					var skillRating = makeSkillRating(personReduced, skills, sKey);
					// console.log("skillRating", skillRating)

					if (sKey in technologiesReduced) {
						writeSkillsRatingByTechnologyPeopleRatedAt(skillRating, technologiesReduced[sKey]);
					}
				}
			}
		}
	}
}
function writeSkillsRatingByTechnologyPeopleRatedAt(skillRating, technologyReduced) {
	switch (skillRating.Rating) {
		case -1:
			// Not Rated, Do nothing
			// console.log("Do Nothing ", skillRating.fullName, " to ", skillRating.skillKey, " at ", skillRating.Rating);
			break;
		case 0:
			// code block
			// console.log("add ", skillRating.fullName, " to ", skillRating.skillKey, " at ", skillRating.Rating);
			return addPersonToRatedAt0(skillRating, technologyReduced);
			break;
		case 1:
			// code block
			// console.log("add ", skillRating.fullName, " to ", skillRating.skillKey, " at ", skillRating.Rating);
			return addPersonToRatedAt1(skillRating, technologyReduced);
		// break;
		case 2:
			// code block
			// console.log("add ", skillRating.fullName, " to ", skillRating.skillKey, " at ", skillRating.Rating);
			return addPersonToRatedAt2(skillRating, technologyReduced);
			break;
		case 3:
			// code block
			return addPersonToRatedAt3(skillRating, technologyReduced);
			break;
		default:
		// code block
	}
}
function addPersonToRatedAt0(skillRating, technologyReduced) {
	console.log("skillRating.personKey", skillRating.personKey);
	console.log("technologyReduced.peopleRatedAt0", technologyReduced.peopleRatedAt0);
	var peopleRatedAt0 = technologyReduced.peopleRatedAt0 || [];
	// console.log("Object.keys(peopleRatedAt0)", skillRating.skillKey, Object.keys(peopleRatedAt0));
	console.log("peopleRatedAt0 before", peopleRatedAt0);
	if (skillRating.Rating === 0 && !(skillRating.skillKey in peopleRatedAt0)) {
		peopleRatedAt0[skillRating.personKey] = {
			"fullName": skillRating.fullName,
			"email": skillRating.email
		};
		console.log("peopleRatedAt0 after", peopleRatedAt0);
		__WEBPACK_IMPORTED_MODULE_6__vue_service_database_js__["h" /* skillsRatingRef */].child("byTechnology").child(skillRating.skillKey).child("peopleRatedAt0").set(peopleRatedAt0);
	}
}
function addPersonToRatedAt1(skillRating, technologyReduced) {
	var peopleRatedAt1 = technologyReduced.peopleRatedAt1 || [];
	console.log("Object.keys(peopleRatedAt1)", skillRating.skillKey, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(peopleRatedAt1));
	console.log("peopleRatedAt1", peopleRatedAt1);
	console.log("Object.keys(peopleRatedAt1)", __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(peopleRatedAt1));
	console.log("peopleRatedAt1 before", peopleRatedAt1);
	if (skillRating.Rating === 1 && !(skillRating.skillKey in peopleRatedAt1)) {
		peopleRatedAt1[skillRating.personKey] = {
			"fullName": skillRating.fullName,
			"email": skillRating.email
		};
		console.log("peopleRatedAt1", skillRating.skillKey, peopleRatedAt1[skillRating.personKey]);
		return __WEBPACK_IMPORTED_MODULE_6__vue_service_database_js__["h" /* skillsRatingRef */].child("byTechnology").child(skillRating.skillKey).child("peopleRatedAt1").set(peopleRatedAt1);
	}
	console.log("peopleRatedAt0 after", peopleRatedAt1);
}
function addPersonToRatedAt2(skillRating, technologyReduced) {
	var peopleRatedAt2 = technologyReduced.peopleRatedAt2 || [];
	console.log("Object.keys(peopleRatedAt2)", skillRating.skillKey, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(peopleRatedAt2));
	console.log("peopleRatedAt1", peopleRatedAt2);
	console.log("Object.keys(peopleRatedAt2)", __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(peopleRatedAt2));
	if (skillRating.Rating === 2 && !(skillRating.skillKey in peopleRatedAt2)) {
		peopleRatedAt2[skillRating.personKey] = {
			"fullName": skillRating.fullName,
			"email": skillRating.email
		};
		return __WEBPACK_IMPORTED_MODULE_6__vue_service_database_js__["h" /* skillsRatingRef */].child("byTechnology").child(skillRating.skillKey).child("peopleRatedAt2").set(peopleRatedAt2);
	}
}
function addPersonToRatedAt3(skillRating, technologyReduced) {
	var peopleRatedAt3 = technologyReduced.peopleRatedAt3 || [];
	console.log("Object.keys(peopleRatedAt3)", skillRating.skillKey, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(peopleRatedAt3));
	console.log("peopleRatedAt1", peopleRatedAt3);
	console.log("Object.keys(peopleRatedAt3)", __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(peopleRatedAt3));
	if (skillRating.Rating === 3 && !(skillRating.skillKey in peopleRatedAt3)) {
		peopleRatedAt3[skillRating.personKey] = {
			"fullName": skillRating.fullName,
			"email": skillRating.email
		};
		return __WEBPACK_IMPORTED_MODULE_6__vue_service_database_js__["h" /* skillsRatingRef */].child("byTechnology").child(skillRating.skillKey).child("peopleRatedAt3").set(peopleRatedAt3);
	}
}
function reducePeople(people) {
	var peopleReduced = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(people).map(function (pKey) {
		return pKey;
	}).reduce(function (acc, pK) {
		acc[pK] = {
			"fullName": people[pK].fName + " " + people[pK].lName,
			"email": people[pK].email,
			"key": pK
		};
		return acc;
	}, []);
	return peopleReduced;
}
function reduceTechnologies(technologies) {
	var technologiesReduced = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(technologies).map(function (tKey) {
		return tKey;
	}).reduce(function (acc, tK) {
		acc[tK] = {
			"peopleRatedAt0": technologies[tK].peopleRatedAt0 || "",
			"peopleRatedAt1": technologies[tK].peopleRatedAt1 || "",
			"peopleRatedAt2": technologies[tK].peopleRatedAt2 || "",
			"peopleRatedAt3": technologies[tK].peopleRatedAt3 || ""
		};
		return acc;
	}, []);
	return technologiesReduced;
}
function makeSkillRating(personReduced, skills, skillKey) {
	return {
		"Rating": skills[skillKey].Rating,
		"fullName": personReduced.fullName,
		"email": personReduced.email,
		"skillKey": skillKey,
		"personKey": personReduced.key
	};
}

function updateSkillsRatingTechs() {
	// Used once to transfer tech info to byPeople array
	var byPeople = store.getters.skillsRatingByPerson;
	var technologies = store.getters.technology;

	var updatedByPeople = {};
	for (var key in byPeople) {
		var person = byPeople[key];
		var updatedPerson = { skills: {} };
		var skills = person.skills;
		for (var techKey in skills) {
			updatedPerson.skills[techKey] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, skills[techKey], technologies[techKey]);
		}
		updatedByPeople[key] = updatedPerson;
	}

	transferTechDataToByPeople(updatedByPeople);
}
function deleteSkillsRatingByPersonSkillNode(personKey, skillKey) {
	return __WEBPACK_IMPORTED_MODULE_6__vue_service_database_js__["h" /* skillsRatingRef */].child("byPerson").child(personKey).child("skills").child(skillKey).set(null);
}
function transferTechDataToByPeople(updatedByPeople) {
	__WEBPACK_IMPORTED_MODULE_6__vue_service_database_js__["h" /* skillsRatingRef */].child("byPerson").set(updatedByPeople);
}




/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	SET_USER: function SET_USER(context, payload) {
		context.commit("SET_USER", payload);
	},
	SET_AUTHORIZED: function SET_AUTHORIZED(context, payload) {
		context.commit("SET_AUTHORIZED", payload);
	},
	SET_ADMINISTRATOR: function SET_ADMINISTRATOR(context, payload) {
		context.commit("SET_ADMINISTRATOR", payload);
	},
	SET_TOKEN: function SET_TOKEN(context, payload) {
		context.commit("SET_TOKEN", payload);
	},
	SET_SELECTED_PERSON_KEY: function SET_SELECTED_PERSON_KEY(context, payload) {
		context.commit("SET_SELECTED_PERSON_KEY", payload);
	},
	SET_SELECTED_PERSON_VEHICLES: function SET_SELECTED_PERSON_VEHICLES(context, payload) {
		context.commit("SET_SELECTED_PERSON_VEHICLES", payload);
	},
	SET_SELECTED_PERSON_IS_USER: function SET_SELECTED_PERSON_IS_USER(context, payload) {
		context.commit("SET_SELECTED_PERSON_IS_USER", payload);
	},
	SET_PEOPLE: function SET_PEOPLE(context, payload) {
		context.commit("SET_PEOPLE", payload);
	},
	SET_TECHNOLOGY: function SET_TECHNOLOGY(context, payload) {
		context.commit("SET_TECHNOLOGY", payload);
	},
	SET_SKILLS_RATING_BY_TECHNOLOGY: function SET_SKILLS_RATING_BY_TECHNOLOGY(context, payload) {
		context.commit("SET_SKILLS_RATING_BY_TECHNOLOGY", payload);
	},
	SET_SKILLS_RATING_BY_PERSON: function SET_SKILLS_RATING_BY_PERSON(context, payload) {
		context.commit("SET_SKILLS_RATING_BY_PERSON", payload);
	},
	SET_SELECTED_PERSON_SKILLS_RATING: function SET_SELECTED_PERSON_SKILLS_RATING(context, payload) {
		context.commit("SET_SELECTED_PERSON_SKILLS_RATING", payload);
	},
	SET_PERSON: function SET_PERSON(context, payload) {
		context.commit("SET_PERSON", payload);
	},
	SET_GROUPS: function SET_GROUPS(context, payload) {
		context.commit("SET_GROUPS", payload);
	},
	SET_SELECTED_GROUP_KEY: function SET_SELECTED_GROUP_KEY(context, payload) {
		context.commit("SET_SELECTED_GROUP_KEY", payload);
	},
	SET_SELECTED_GROUP: function SET_SELECTED_GROUP(context, payload) {
		context.commit("SET_SELECTED_GROUP", payload);
	},
	SET_MEMBERSHIPS: function SET_MEMBERSHIPS(context, payload) {
		context.commit("SET_MEMBERSHIPS", payload);
	},
	SET_SELECTED_GROUP_MEMBERS: function SET_SELECTED_GROUP_MEMBERS(context, payload) {
		context.commit("SET_SELECTED_GROUP_MEMBERS", payload);
	},
	SET_SELECTED_MEMBER_KEY: function SET_SELECTED_MEMBER_KEY(context, payload) {
		context.commit("SET_SELECTED_MEMBER_KEY", payload);
	},
	SET_SELECTED_MEMBER: function SET_SELECTED_MEMBER(context, payload) {
		context.commit("SET_SELECTED_MEMBER", payload);
	},
	SET_SELECTED_MEMBERSHIPS: function SET_SELECTED_MEMBERSHIPS(context, payload) {
		context.commit("SET_SELECTED_MEMBERSHIPS", payload);
	},
	SET_SELECTED_SLACK_MEMBER: function SET_SELECTED_SLACK_MEMBER(context, payload) {
		context.commit("SET_SELECTED_SLACK_MEMBER", payload);
	},
	SET_SELECTED_SLACK_MEMBERSHIPS: function SET_SELECTED_SLACK_MEMBERSHIPS(context, payload) {
		context.commit("SET_SELECTED_SLACK_MEMBERSHIPS", payload);
	},
	SET_BIRTHDAYS_THIS_MONTH: function SET_BIRTHDAYS_THIS_MONTH(context, payload) {
		context.commit("SET_BIRTHDAYS_THIS_MONTH", payload);
	},
	SET_ANNIVERSARIES_THIS_MONTH: function SET_ANNIVERSARIES_THIS_MONTH(context, payload) {
		context.commit("SET_ANNIVERSARIES_THIS_MONTH", payload);
	},
	SET_TOGGL_PROJECTS: function SET_TOGGL_PROJECTS(context, payload) {
		context.commit("SET_TOGGL_PROJECTS", payload);
	},
	SET_PROJECTS_MANAGEMENT_OVERVIEW: function SET_PROJECTS_MANAGEMENT_OVERVIEW(context, payload) {
		context.commit("SET_PROJECTS_MANAGEMENT_OVERVIEW", payload);
	},
	SET_PROJECTS_MANAGEMENT_DETAILS: function SET_PROJECTS_MANAGEMENT_DETAILS(context, payload) {
		context.commit("SET_PROJECTS_MANAGEMENT_DETAILS", payload);
	},
	SET_SELECTED_PROJECT_KEY: function SET_SELECTED_PROJECT_KEY(context, payload) {
		context.commit("SET_SELECTED_PROJECT_KEY", payload);
	},
	SET_PROJECT: function SET_PROJECT(context, payload) {
		context.commit("SET_PROJECT", payload);
	}
});

/***/ }),

/***/ "nK8i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      headersBirthday: [{
        text: "Name",
        align: "center",
        sortable: true,
        value: "name"
      }, {
        text: "Birthday",
        align: "center",
        value: "birthDate"
      }],
      headersAnniversaries: [{
        text: "Name",
        align: "center",
        sortable: true,
        value: "name"
      }, {
        text: "Years",
        align: "center",
        value: "years"
      }]
    };
  },

  computed: {
    birthdaysThisMonth: function birthdaysThisMonth() {
      var birthdays = this.$store.getters.birthdaysThisMonth;
      if (birthdays === null) return null;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(birthdays);
    },
    anniversariesThisMonth: function anniversariesThisMonth() {
      var anniversaries = this.$store.getters.anniversariesThisMonth;
      if (anniversaries === null) return null;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(anniversaries);
      var date = new Date();
    }
  }
});

/***/ }),

/***/ "nNMv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavDrawer_vue__ = __webpack_require__("uKVQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c5cc5f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavDrawer_vue__ = __webpack_require__("VZjw");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("vcOl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c5cc5f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavDrawer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c5cc5f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavDrawer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/NavDrawer.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6c5cc5f4", Component.options)
  } else {
    hotAPI.reload("data-v-6c5cc5f4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nqH1":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.person-page[data-v-35d18db8]{\n  flex-grow: 1;\n  margin-left: -10px;\n  margin-right: 10px;\n}\n.person-header[data-v-35d18db8]{\n  height: 18vh;\n  width: 100%;\n}\n.person-name-container[data-v-35d18db8]{\n  height: 100%;\n  display: flex;\n  position: relative;\n  left: calc(100px + 22vh);\n  padding-left: 20px;\n  position: relative;\n}\n.person-name-container div[data-v-35d18db8]{\n  align-self: flex-end;\n  padding-bottom: 20px;\n}\n.person-name[data-v-35d18db8]{\n  font-size: 16pt;\n  font-weight: bold;\n}\n.profile-picture[data-v-35d18db8]{\n  width: 22vh;\n  height: 22vh;\n  border-style: solid;\n  border-color: white;\n  border-width: 4px;\n  border-radius: 50%;\n  position: relative;\n  top: -16vh;\n  left: 100px;\n  box-shadow: 0px 2px 5px 1px rgba(0, 0, 0, 0.2);\n}\n.field-label[data-v-35d18db8]{\n  color:rgba(0, 0, 0, 0.4);\n  text-transform: uppercase;\n  font-weight: bold;\n  padding-bottom: 5px;\n}\n.field-data[data-v-35d18db8]{\n  padding-left: 20px;\n  padding-bottom: 10px;\n}\n.user-info[data-v-35d18db8]{\n  margin-top: -15vh\n}\n.tab-header[data-v-35d18db8]{\n  border-style: solid;\n  border-width: 0px 0px 1px 0px;\n  border-color: rgba(0, 0, 0, 0.2);\n}\n.card-title[data-v-35d18db8]{\n  text-transform: uppercase;\n  font-size: .875rem;\n  font-weight: 500;\n  letter-spacing: .0892857143em;\n  width: calc(100% + 32px);\n  border-width: 0px 0px 1px 0px;\n  border-style: solid;\n  border-color: rgba(0, 0, 0, 0.2);\n  margin: -16px;\n  padding: 13px 32px 13px 32px;\n}\n.flex-title[data-v-35d18db8]{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.card-subtitle[data-v-35d18db8]{\n  font-size: .875rem;\n  font-weight: 500;\n  padding: 0px 16px;\n  letter-spacing: .0892857143em;\n}\n.project-chart[data-v-35d18db8]{\n  display: flex;\n  align-items: center;\n}\n.chart[data-v-35d18db8]{\n  width: 50%;\n}\n.project-color[data-v-35d18db8]{\n  display: inline-block;\n  height: 8px;\n  width: 32px;\n  border-radius: 4px;\n  margin-right: 20px;\n}\n.side-hustle-switch[data-v-35d18db8]{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0px;\n}\n.side-hustle-title[data-v-35d18db8]{\n  font-size: 12pt;\n  font-weight: bold;\n}\n.side-hustle-field[data-v-35d18db8]{\n  padding: 5px 0px;\n}\n.unbulleted-list[data-v-35d18db8]{\n  list-style: none;\n}\n.skill-li[data-v-35d18db8]{\n  font-weight: bold;\n  margin-top: 10px;\n  margin-bottom: 5px;\n  width: 50%;\n  display: flex;\n  justify-content: space-between;\n}\nhr[data-v-35d18db8] {\n  border: none;\n  height: 1px;\n  background-color: rgba(0, 0, 0, 0.2);\n}\n.core-icon[data-v-35d18db8]{\n  margin-left: 20px;\n}\n.edit-tab[data-v-35d18db8]{\n  position: absolute;\n  z-index: 2;\n  width: 100%;\n  display: flex;\n  justify-content: right;\n  padding: 5px 5px 0px 0px;\n}\n.tab-page[data-v-35d18db8]{\n  position: relative;\n}\n.name-edit-text-field[data-v-35d18db8]{\n  display: inline-block;\n}\n.edit-name-header[data-v-35d18db8]{\n  position: absolute;\n  width: 100%;\n  padding-right: calc(140px + 22vh);\n  display: flex;\n  justify-content: right;\n}\n.no-skills-label[data-v-35d18db8]{\n  font-weight: normal;\n}\n.skill-image[data-v-35d18db8]{\n  margin-right: 10px;\n}\n.skill-label[data-v-35d18db8]{\n  display: flex;\n  justify-content: left;\n  align-items: center;\n}\n", ""]);

// exports


/***/ }),

/***/ "orMY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      firstSelection: true
    };
  },
  props: ["people"],
  methods: {
    selectPerson: function selectPerson(person) {
      this.firstSelection = false;
      this.$emit("selectPerson", person);
    },
    scrollToSelectedPerson: function scrollToSelectedPerson() {
      var el = this.$el.getElementsByClassName('selected-person')[0];

      if (el) {
        el.scrollIntoView();
      }
    }
  },
  mounted: function mounted() {
    this.firstSelection = true;
  },

  computed: {
    selectedPerson: function selectedPerson() {
      var _this = this;

      // TODO !! This feels like a pretty hacky way to do this... but it works
      // If this is the first selection this time the component mounted, scroll to the person
      if (this.firstSelection) {
        this.$nextTick(function () {
          return _this.scrollToSelectedPerson();
        });
      }
      return this.$store.getters.people[this.$store.getters.selectedPersonKey];
    }
  }
});

/***/ }),

/***/ "pWcd":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.filter-bar[data-v-2e395e08]{\n  display: flex;\n  align-items: center;\n}\n.filter-item[data-v-2e395e08]{\n  width: 90%\n}\n.filter-item-checkbox[data-v-2e395e08]{\n  margin-left: 10px;\n}\n.filter-item + .filter-item[data-v-2e395e08]{\n  margin-left: 10px;\n}\n.filter-select[data-v-2e395e08]{\n  max-width: 14% !important;\n}\n.spacing[data-v-2e395e08]{\n  margin-left: 10px;\n}\n", ""]);

// exports


/***/ }),

/***/ "paoq":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.secondary.v-card.v-sheet.theme--light[data-v-54f74f74] {\n    flex: 1 1 auto!important;\n}\n", ""]);

// exports


/***/ }),

/***/ "psNk":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("DlZj");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3fc28464", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b23842e2\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./JG_Logo.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b23842e2\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./JG_Logo.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "r+dV":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("1+6L");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3850594a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-befa09e2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Groups.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-befa09e2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Groups.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "r3lP":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* style the userImage to fit in nav */\n.toolbar-title-img[data-v-81440b78] {\n  max-width: 35px;\n}\n.beta-text[data-v-81440b78] {\n  /* font-size: .75em; */\n  color: lightcoral;\n}\n.logo[data-v-81440b78]{\n  font-weight: bold;\n  font-size: 30px;\n}\n.main-nav[data-v-81440b78]{\n  z-index: 10;\n  position: fixed;\n  width: 100%;\n}\n", ""]);

// exports


/***/ }),

/***/ "s/sK":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("i6U6");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("855efe86", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-58849936\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ProjectChart.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-58849936\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ProjectChart.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "sLfu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Project_vue__ = __webpack_require__("16gp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41bd5494_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Project_vue__ = __webpack_require__("ZW1X");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("+/SB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Project_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41bd5494_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Project_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Projects/Project.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-41bd5494", Component.options)
  } else {
    hotAPI.reload("data-v-41bd5494", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "skFd":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* style the userImage to fit in nav */\n.toolbar-title-img[data-v-0cce41e2] {\n  max-width: 35px;\n}\n.beta-text[data-v-0cce41e2] {\n  /* font-size: .75em; */\n  color: lightcoral;\n}\n", ""]);

// exports


/***/ }),

/***/ "spdE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_service_form_person__ = __webpack_require__("Ohp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_service_validation__ = __webpack_require__("XkyN");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      newEmail: "email@jahnelgroup.com",
      newFirstName: null,
      newLastName: null,
      addPersonFormIsValid: false,
      validationRules: __WEBPACK_IMPORTED_MODULE_2__vue_service_validation__["a" /* validationRules */],
      addPersonOpen: false
    };
  },

  computed: {
    userIsAdmin: function userIsAdmin() {
      return this.$store.getters.administrator;
    }
  },
  methods: {
    emailIsUnique: __WEBPACK_IMPORTED_MODULE_2__vue_service_validation__["b" /* emailIsUnique */],
    addPerson: function addPerson() {
      // Get list of all techs
      var techs = this.$store.getters.technology;

      // Set up an empty skills object
      var skills = {};

      // Transfer every skill to the skilsl object
      for (var key in techs) {
        var tech = techs[key];
        var timestamp = Date.now();

        // Create a new changelog with initialized ratings and interested status
        var changelog = {};
        changelog[timestamp.toString()] = { Rating: -1, Interested: false };

        // Assign all tech details and rating, interested and changelog to the skill
        skills[key] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ Rating: -1, Interested: false, Changelog: changelog }, tech);
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__vue_service_form_person__["a" /* addNewPerson */])(this.newEmail, this.newFirstName, this.newLastName, skills);
      this.addPersonOpen = false;
      this.clearAddDialogFields();
    },
    clearAddDialogFields: function clearAddDialogFields() {
      this.$refs.addPersonForm.reset();
      this.newEmail = "email@jahnelgroup.com";
      this.newFirstName = null;
      this.newLastName = null;
    }
  }
});

/***/ }),

/***/ "u6kN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_service_auth__ = __webpack_require__("EREM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_service_utility__ = __webpack_require__("mEcL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_service_database__ = __webpack_require__("LLs5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_service_skills__ = __webpack_require__("xDPB");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      administratorsRef: __WEBPACK_IMPORTED_MODULE_2__vue_service_database__["a" /* administratorsRef */],
      email: "email@jahnelgroup.com",
      rules: {
        // validate the email format
        required: function required(value) {
          return !!value || "Required.";
        },
        email: function email(value) {
          var pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      },
      deleteDialog: false,
      isDuplicateEmail: false,
      selectedAdministrator: {
        key: "",
        email: ""
      }
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    administrator: function administrator() {
      return this.$store.getters.administrator;
    }
  },
  firebase: {
    people: __WEBPACK_IMPORTED_MODULE_2__vue_service_database__["c" /* peopleRef */],
    administrators: __WEBPACK_IMPORTED_MODULE_2__vue_service_database__["a" /* administratorsRef */]
  },
  methods: {
    addPerson: function addPerson() {
      __WEBPACK_IMPORTED_MODULE_2__vue_service_database__["c" /* peopleRef */].push({ email: this.email, edit: false });
    },
    addAdministrator: function addAdministrator(ref) {
      this.isDuplicateEmail = this.administrators.map(function (a) {
        return a.email;
      }).includes(this.email);

      if (!this.isDuplicateEmail) {
        ref.push({ email: this.email, edit: false });
      }
    },
    removePerson: function removePerson(key) {
      __WEBPACK_IMPORTED_MODULE_2__vue_service_database__["c" /* peopleRef */].child(key).remove();
    },
    removeAdministrator: function removeAdministrator(key) {
      __WEBPACK_IMPORTED_MODULE_2__vue_service_database__["a" /* administratorsRef */].child(key).remove();
    },
    setAdministratorKey: function setAdministratorKey(key) {
      this.selectedAdministrator.key = key;
      console.log("selectedAdministrator.key: ", this.selectedAdministrator.key);
    },
    setAdministratorEmail: function setAdministratorEmail(email) {
      this.selectedAdministrator.email = email;
      console.log("selectedAdministrator.email: ", this.selectedAdministrator.email);
    },
    eraseSkills: function eraseSkills() {
      console.log("Erase PeopleRatedAt Feature Not Enablbled");
      // erasePeopleRatedAt();
    },
    updateSkills: function updateSkills() {
      console.log("Update PeopleRatedAt Feature Not Enablbled");
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__vue_service_utility__["a" /* fillPeopleRatedAt */])();
    },
    findPeople: function findPeople() {
      console.log("Ding");
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__vue_service_utility__["b" /* findPeopleToLog */])();
    },
    findMissingTech: function findMissingTech() {
      console.log("techprops Go!");
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__vue_service_utility__["c" /* findMissingTechProperties */])();
    }
  }
});

/***/ }),

/***/ "uKVQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "navdrawer",
  data: function data() {
    return {
      menuItems: [
      // { icon: "person", title: "People", link: "/people", admin: false, authorized: true, selected: false },
      { icon: 'group', title: 'Groups', link: "groups", admin: false, authorized: true, selected: false }, { icon: "business_center", title: "Skills", link: "/skills", admin: false, selected: false }, { icon: "assignment", title: "Roles", link: "roles", admin: true, authorized: true, selected: false
        // { icon: "build", title: "Settings", link: "settings", admin: false, authorized: true, selected: false },
      }]
    };
  },

  computed: {
    authorized: function authorized() {
      return this.$store.getters.authorized;
    },
    administrator: function administrator() {
      return this.$store.getters.administrator;
    },
    filteredMenuItems: function filteredMenuItems() {
      // Filter menu items depending on admin status
      if (this.administrator) {
        return this.menuItems;
      } else if (this.authorized) {
        return this.menuItems.filter(function (menuItems) {
          return menuItems.admin === false;
        }).map(function (item) {
          if (window.location.pathname.includes(item.link)) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item, { selected: true });
          }
          return item;
        });
      }
    }
  }
});

/***/ }),

/***/ "uZUK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_downloadjs__ = __webpack_require__("sJst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_downloadjs__);

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		// mime type [xls, csv], default: xls
		'type': {
			type: String,
			default: "xls"
		},
		// Json to download
		'data': {
			type: Array,
			required: true
		},
		// fields inside the Json Object that you want to export
		// if no given, all the properties in the Json are exported
		'fields': {
			type: Object,
			required: true
		},
		// Title for the data
		'title': {
			type: String,
			default: null
		},
		// filename to export, deault: data.xls
		'name': {
			type: String,
			default: "data.xls"
		},
		'meta': {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	},
	computed: {
		// unique identifier
		idName: function idName() {
			var now = new Date().getTime();
			return 'export_' + now;
		}
	},
	methods: {
		generate: function generate() {
			if (!this.data.length) {
				return;
			}
			var json = this.getProcessedJson(this.data, this.fields);
			if (this.type == 'csv') {
				return this.export(this.jsonToCSV(json), this.name, "application/csv");
			}
			return this.export(this.jsonToXLS(json), this.name, "application/vnd.ms-excel");
		},

		/*
  Use downloadjs to generate the download link
  */
		export: function _export(data, filename, mime) {
			var blob = this.base64ToBlob(data, mime);
			__WEBPACK_IMPORTED_MODULE_1_downloadjs___default()(blob, filename, mime);
		},
		/*
  jsonToXLS
  ---------------
  Transform json data into an xml document with MS Excel format, sadly
  this format show a prompt when open due to a default behavior
  on Microsoft office. It's recommended to use CSV format instead.
  */
		jsonToXLS: function jsonToXLS(data) {
			var xlsTemp = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>${table}</table></body></html>';
			var xlsData = '<thead><tr>';

			if (this.title != null) {
				xlsData += '<tr><th colspan="' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data[0]).length + '">' + this.title + '<th></tr>';
			}

			for (var key in data[0]) {
				xlsData += '<th>' + key + '</th>';
			}
			xlsData += '</tr></thead>';
			xlsData += '<tbody>';

			data.map(function (item, index) {
				xlsData += '<tbody><tr>';
				for (var _key in item) {
					xlsData += '<td>' + item[_key] + '</td>';
				}
				xlsData += '</tr></tbody>';
			});
			return xlsTemp.replace('${table}', xlsData);
		},
		/*
  jsonToCSV
  ---------------
  Transform json data into an CSV file.
  */
		jsonToCSV: function jsonToCSV(data) {
			var csvData = '';

			if (this.title != null) {
				csvData += this.title + '\r\n';
			}

			for (var key in data[0]) {
				csvData += key + ',';
			}
			csvData = csvData.slice(0, csvData.length - 1);
			csvData += '\r\n';

			data.map(function (item) {
				for (var _key2 in item) {
					var escapedCSV = item[_key2] + ''; // cast Numbers to string
					if (escapedCSV.match(/[,"\n]/)) {
						escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"';
					}
					csvData += escapedCSV + ',';
				}
				csvData = csvData.slice(0, csvData.length - 1);
				csvData += '\r\n';
			});
			return csvData;
		},
		/*
  getProcessedJson
  ---------------
  Get only the data to export, if no fields are set return all the data
  */
		getProcessedJson: function getProcessedJson(data, header) {
			var keys = this.getKeys(data, header);
			var newData = [];
			var _self = this;
			data.map(function (item, index) {
				var newItem = {};
				for (var label in keys) {
					var property = keys[label];
					newItem[label] = _self.getNestedData(property, item);
				}
				newData.push(newItem);
			});

			return newData;
		},
		getKeys: function getKeys(data, header) {
			if (header) {
				return header;
			}

			var keys = {};
			for (var key in data[0]) {
				keys[key] = key;
			}
			return keys;
		},
		getNestedData: function getNestedData(key, item) {
			var valueFromNestedKey = null;
			var keyNestedSplit = key.split(".");
			valueFromNestedKey = item[keyNestedSplit[0]];
			for (var j = 1; j < keyNestedSplit.length; j++) {
				valueFromNestedKey = valueFromNestedKey[keyNestedSplit[j]];
			}
			return valueFromNestedKey == null ? '' : valueFromNestedKey;
		},
		base64ToBlob: function base64ToBlob(data, mime) {
			var base64 = window.btoa(window.unescape(encodeURIComponent(data)));
			var bstr = atob(base64);
			var n = bstr.length;
			var u8arr = new Uint8ClampedArray(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], { type: mime });
		} // end methods
	} });

/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	SET_USER: function SET_USER(state, user) {
		// let emailParts = user.email.split("@")
		// let userDomain = emailParts[1]
		// state.authenticated = !!user && (userDomain == '@jahnelgroup.com')

		state.authenticated = !!user;
		state.user = {
			email: user ? user.email : null,
			displayName: user ? user.displayName : null,
			photoURL: user ? user.photoURL : null
		};
	},
	SET_AUTHORIZED: function SET_AUTHORIZED(state, user) {
		// Check if the user is logged in
		if (!user) {
			state.authorized = false;
		} else {
			var emailParts = user.email.split("@");
			var userDomain = emailParts[1];
			state.authorized = !!user && userDomain == "jahnelgroup.com";
		}
	},
	SET_ADMINISTRATOR: function SET_ADMINISTRATOR(state, payload) {
		// set the administrator state to false
		// if user's email is in the administrator list
		// then set the administrator state to true 
		state.administrator = false;
		var administratorsQuery = payload.administratorsEmail.orderByChild("email");
		administratorsQuery.once("value").then(function (snapshot) {
			snapshot.forEach(function (childSnapshot) {
				var childData = childSnapshot.val();
				if (childData.email == payload.user.email) {
					state.administrator = true;
				}
			});
		});
	},
	SET_TOKEN: function SET_TOKEN(state, payload) {
		state.token = payload;
	},
	SET_SELECTED_PERSON_KEY: function SET_SELECTED_PERSON_KEY(state, payload) {
		state.selectedPersonKey = payload;
	},
	SET_SELECTED_PERSON_VEHICLES: function SET_SELECTED_PERSON_VEHICLES(state, payload) {
		state.selectedPersonVehicles = payload;
	},
	SET_PEOPLE: function SET_PEOPLE(state, payload) {
		state.people = payload;
	},
	SET_TECHNOLOGY: function SET_TECHNOLOGY(state, payload) {
		state.technology = payload;
	},
	SET_SKILLS_RATING_BY_TECHNOLOGY: function SET_SKILLS_RATING_BY_TECHNOLOGY(state, payload) {
		state.skillsRatingByTechnology = payload;
	},
	SET_PERSON: function SET_PERSON(state, payload) {
		// console.log("payload: ", payload)
		state.person = {
			email: payload.email,
			fName: payload.fName,
			lName: payload.lName,
			nName: payload.nName,
			title: payload.title,
			phone1: payload.phone1,
			phone2: payload.phone2,
			email1: payload.email1,
			email2: payload.email2,
			street: payload.street,
			city: payload.city,
			zip: payload.zip,
			emergencyName: payload.emergencyName,
			emergencyRelationship: payload.emergencyRelationship,
			emergencyPhone1: payload.emergencyPhone1,
			emergencyPhone2: payload.emergencyPhone2,
			vehicleMakeModel: payload.vehicleMakeModel,
			licensePlateNumber: payload.licensePlateNumber,
			id: payload.id,
			birthDate: payload.birthDate,
			startDate: payload.startDate,
			status: payload.status,
			group: payload.group,
			shareBirthDate: payload.shareBirthDate,
			teamPage: payload.teamPage,
			kelmarId: payload.kelmarId,
			onsipExtension: payload.onsipExtension
		};
	},
	SET_SELECTED_PERSON_IS_USER: function SET_SELECTED_PERSON_IS_USER(state) {
		if (state.person.email == state.user.email) {
			state.selectedPersonIsUser = true;
		} else {
			state.selectedPersonIsUser = false;
		}
	},
	SET_GROUPS: function SET_GROUPS(state, payload) {
		state.groups = payload;
	},
	SET_SELECTED_GROUP_KEY: function SET_SELECTED_GROUP_KEY(state, payload) {
		state.selectedGroupKey = payload;
	},
	SET_SELECTED_GROUP: function SET_SELECTED_GROUP(state, payload) {
		state.selectedGroup = payload;
	},
	SET_SELECTED_GROUP_MEMBERS: function SET_SELECTED_GROUP_MEMBERS(state, payload) {
		state.selectedGroupMembers = payload;
	},
	SET_MEMBERSHIPS: function SET_MEMBERSHIPS(state, payload) {
		state.memberships = payload;
	},
	SET_SELECTED_MEMBER_KEY: function SET_SELECTED_MEMBER_KEY(state, payload) {
		state.selectedMemberKey = payload;
	},
	SET_SELECTED_MEMBER: function SET_SELECTED_MEMBER(state, payload) {
		state.selectedMember = payload;
	},
	SET_SELECTED_MEMBERSHIPS: function SET_SELECTED_MEMBERSHIPS(state, payload) {
		state.selectedMemberships = payload;
	},
	SET_SELECTED_SLACK_MEMBER: function SET_SELECTED_SLACK_MEMBER(state, payload) {
		state.selectedSlackMember = payload;
	},
	SET_SELECTED_SLACK_MEMBERSHIPS: function SET_SELECTED_SLACK_MEMBERSHIPS(state, payload) {
		state.selectedSlackMemberships = payload;
	},
	SET_BIRTHDAYS_THIS_MONTH: function SET_BIRTHDAYS_THIS_MONTH(state, payload) {
		state.birthdaysThisMonth = payload;
	},
	SET_ANNIVERSARIES_THIS_MONTH: function SET_ANNIVERSARIES_THIS_MONTH(state, payload) {
		state.anniversariesThisMonth = payload;
	},
	SET_TOGGL_PROJECTS: function SET_TOGGL_PROJECTS(state, payload) {
		state.togglProjects = payload;
	},
	SET_PROJECTS_MANAGEMENT_OVERVIEW: function SET_PROJECTS_MANAGEMENT_OVERVIEW(state, payload) {
		state.projectsManagementOverview = payload;
	},
	SET_PROJECTS_MANAGEMENT_DETAILS: function SET_PROJECTS_MANAGEMENT_DETAILS(state, payload) {
		state.projectsManagementDetails = payload;
	},
	SET_SELECTED_PROJECT_KEY: function SET_SELECTED_PROJECT_KEY(state, payload) {
		state.selectedProjectKey = payload;
	},
	SET_PROJECT: function SET_PROJECT(state, payload) {
		state.project = payload;
	},
	SET_SKILLS_RATING_BY_PERSON: function SET_SKILLS_RATING_BY_PERSON(state, payload) {
		state.skillsRatingByPerson = payload;
	},
	SET_SELECTED_PERSON_SKILLS_RATING: function SET_SELECTED_PERSON_SKILLS_RATING(state, payload) {
		state.selectedPersonSkillsRating = payload;
	}
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vSLk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-xs": "" } },
    [
      _c("v-flex", [
        _c(
          "div",
          { staticClass: "filter-bar" },
          [
            _c(
              "v-flex",
              {
                staticClass: "align-self-end",
                attrs: { "ma-2": "", xs12: "", sm12: "", md2: "" }
              },
              [
                _c("v-label", [_vm._v("Person")]),
                _vm._v(" "),
                _c("v-select", {
                  attrs: {
                    "item-text": _vm.getName,
                    "item-value": "email",
                    items: _vm.getPpl,
                    "hide-default-footer": "",
                    dense: "",
                    disabled: _vm.editing
                  },
                  on: { input: _vm.changeSelectedPerson },
                  model: {
                    value: _vm.personEmail,
                    callback: function($$v) {
                      _vm.personEmail = $$v
                    },
                    expression: "personEmail"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              {
                staticClass: "align-self-end",
                attrs: { "ma-2": "", xs12: "", sm12: "", md2: "" }
              },
              [
                _c("v-label", [_vm._v("Categories")]),
                _vm._v(" "),
                _c("v-select", {
                  attrs: {
                    items: _vm.categories,
                    placeholder: "All",
                    multiple: "",
                    "hide-default-footer": "",
                    dense: ""
                  },
                  model: {
                    value: _vm.categoryFilter,
                    callback: function($$v) {
                      _vm.categoryFilter = $$v
                    },
                    expression: "categoryFilter"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              {
                staticClass: "align-self-end",
                attrs: { "ma-2": "", xs12: "", sm12: "", md2: "" }
              },
              [
                _c("v-label", [_vm._v("Proficiency Level")]),
                _vm._v(" "),
                _c("v-select", {
                  attrs: {
                    "item-text": "value",
                    "item-value": "key",
                    placeholder: "All",
                    items: _vm.proficiencies,
                    multiple: "",
                    "hide-default-footer": "",
                    dense: ""
                  },
                  model: {
                    value: _vm.proficiencyFilter,
                    callback: function($$v) {
                      _vm.proficiencyFilter = $$v
                    },
                    expression: "proficiencyFilter"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              [
                _c("v-switch", {
                  attrs: { label: "Show Core Only" },
                  model: {
                    value: _vm.coreFilter,
                    callback: function($$v) {
                      _vm.coreFilter = $$v
                    },
                    expression: "coreFilter"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                staticClass: "primary--text filter-item",
                attrs: { outlined: "" },
                on: { click: _vm.clearFilter }
              },
              [_vm._v("Clear Filters")]
            ),
            _vm._v(" "),
            !_vm.editing && (_vm.userIsSelected || _vm.userIsAdmin)
              ? _c(
                  "v-btn",
                  {
                    staticClass: "primary--text filter-item",
                    attrs: { outlined: "" },
                    on: {
                      click: function($event) {
                        return _vm.enableEditing()
                      }
                    }
                  },
                  [_vm._v("Manage Skills")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.editing && (_vm.userIsSelected || _vm.userIsAdmin)
              ? _c(
                  "v-btn",
                  {
                    staticClass: "primary--text filter-item",
                    attrs: { outlined: "" },
                    on: {
                      click: function($event) {
                        return _vm.saveSkills()
                      }
                    }
                  },
                  [_vm._v("Save")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.editing && (_vm.userIsSelected || _vm.userIsAdmin)
              ? _c(
                  "v-btn",
                  {
                    staticClass: "primary--text filter-item",
                    attrs: { outlined: "" },
                    on: {
                      click: function($event) {
                        _vm.editing = false
                      }
                    }
                  },
                  [_vm._v("Cancel")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("v-spacer", { staticClass: "mt-3" })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "primary" },
        [
          _c(
            "v-card-title",
            [
              _c("h5", { staticClass: "title white--text" }, [
                _vm._v("JG Skills")
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: {
                  dark: "",
                  color: "white",
                  "append-icon": this.search.length === 0 ? "search" : "clear",
                  label: "Search by Skill",
                  "single-line": "",
                  "hide-default-footer": ""
                },
                on: { "click:append": _vm.clearSearch },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c("v-data-table", {
            attrs: {
              headers: _vm.headers,
              items: _vm.getTechSkillsRatings,
              search: _vm.search,
              expanded: _vm.expanded,
              "single-expand": true,
              "item-key": "key",
              "show-expand": ""
            },
            on: {
              "update:expanded": function($event) {
                _vm.expanded = $event
              }
            },
            scopedSlots: _vm._u([
              {
                key: "item.Image",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    item.hasLocalImage
                      ? [
                          _c("v-img", {
                            attrs: { src: item.ImageUrl, "max-width": "5vh" }
                          })
                        ]
                      : [
                          _c("v-img", {
                            attrs: {
                              src: _vm.noImg,
                              alt: "no image",
                              "max-width": "5vh"
                            }
                          })
                        ]
                  ]
                }
              },
              {
                key: "item.Core",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    item.Core === "TRUE"
                      ? _c(
                          "v-icon",
                          {
                            staticClass: "core-icon",
                            attrs: { color: "primary" }
                          },
                          [_vm._v("$jglogo")]
                        )
                      : _vm._e()
                  ]
                }
              },
              {
                key: "item.Interested",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    !_vm.editing && item.interested
                      ? _c("v-icon", { attrs: { color: "primary" } }, [
                          _vm._v("check")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.editing
                      ? _c("v-checkbox", {
                          model: {
                            value: _vm.skillEdits[item.key].interested,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.skillEdits[item.key],
                                "interested",
                                $$v
                              )
                            },
                            expression: "skillEdits[item.key].interested"
                          }
                        })
                      : _vm._e()
                  ]
                }
              },
              {
                key: "header.0Rating",
                fn: function(ref) {
                  var header = ref.header
                  return [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { top: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "span",
                                    _vm._g(
                                      _vm._b(
                                        { staticClass: "tooltip-header" },
                                        "span",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [_vm._v(_vm._s(header.text))]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.proficiencies[1].value))])
                      ]
                    )
                  ]
                }
              },
              {
                key: "item.0Rating",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    !_vm.editing && item.rating === 0
                      ? _c("v-icon", { attrs: { color: "primary" } }, [
                          _vm._v("check")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.editing
                      ? _c(
                          "v-radio-group",
                          {
                            model: {
                              value: _vm.skillEdits[item.key].rating,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.skillEdits[item.key],
                                  "rating",
                                  $$v
                                )
                              },
                              expression: "skillEdits[item.key].rating"
                            }
                          },
                          [_c("v-radio", { attrs: { value: 0 } })],
                          1
                        )
                      : _vm._e()
                  ]
                }
              },
              {
                key: "header.1Rating",
                fn: function(ref) {
                  var header = ref.header
                  return [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { top: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "span",
                                    _vm._g(
                                      _vm._b(
                                        { staticClass: "tooltip-header" },
                                        "span",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [_vm._v(_vm._s(header.text))]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.proficiencies[2].value))])
                      ]
                    )
                  ]
                }
              },
              {
                key: "item.1Rating",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    !_vm.editing && item.rating === 1
                      ? _c("v-icon", { attrs: { color: "primary" } }, [
                          _vm._v("check")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.editing
                      ? _c(
                          "v-radio-group",
                          {
                            model: {
                              value: _vm.skillEdits[item.key].rating,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.skillEdits[item.key],
                                  "rating",
                                  $$v
                                )
                              },
                              expression: "skillEdits[item.key].rating"
                            }
                          },
                          [_c("v-radio", { attrs: { value: 1 } })],
                          1
                        )
                      : _vm._e()
                  ]
                }
              },
              {
                key: "header.2Rating",
                fn: function(ref) {
                  var header = ref.header
                  return [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { top: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "span",
                                    _vm._g(
                                      _vm._b(
                                        { staticClass: "tooltip-header" },
                                        "span",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [_vm._v(_vm._s(header.text))]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.proficiencies[3].value))])
                      ]
                    )
                  ]
                }
              },
              {
                key: "item.2Rating",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    !_vm.editing && item.rating === 2
                      ? _c("v-icon", { attrs: { color: "primary" } }, [
                          _vm._v("check")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.editing
                      ? _c(
                          "v-radio-group",
                          {
                            model: {
                              value: _vm.skillEdits[item.key].rating,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.skillEdits[item.key],
                                  "rating",
                                  $$v
                                )
                              },
                              expression: "skillEdits[item.key].rating"
                            }
                          },
                          [_c("v-radio", { attrs: { value: 2 } })],
                          1
                        )
                      : _vm._e()
                  ]
                }
              },
              {
                key: "header.3Rating",
                fn: function(ref) {
                  var header = ref.header
                  return [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { top: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "span",
                                    _vm._g(
                                      _vm._b(
                                        { staticClass: "tooltip-header" },
                                        "span",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [_vm._v(_vm._s(header.text))]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.proficiencies[4].value))])
                      ]
                    )
                  ]
                }
              },
              {
                key: "item.3Rating",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    !_vm.editing && item.rating === 3
                      ? _c("v-icon", { attrs: { color: "primary" } }, [
                          _vm._v("check")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.editing
                      ? _c(
                          "v-radio-group",
                          {
                            model: {
                              value: _vm.skillEdits[item.key].rating,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.skillEdits[item.key],
                                  "rating",
                                  $$v
                                )
                              },
                              expression: "skillEdits[item.key].rating"
                            }
                          },
                          [_c("v-radio", { attrs: { value: 3 } })],
                          1
                        )
                      : _vm._e()
                  ]
                }
              },
              {
                key: "expanded-item",
                fn: function(ref) {
                  var headers = ref.headers
                  var item = ref.item
                  return [
                    _c("td", { attrs: { colspan: headers.length } }, [
                      _vm._v(_vm._s(item.Description))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ea413962", esExports)
  }
}

/***/ }),

/***/ "vax7":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("wULM");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("79060927", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "vcOl":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("19Us");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("85e94f6e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6c5cc5f4\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NavDrawer.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6c5cc5f4\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NavDrawer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "wSyU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingPage_vue__ = __webpack_require__("GZQa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54f74f74_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingPage_vue__ = __webpack_require__("SF+z");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("IaSg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54f74f74"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54f74f74_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/LandingPage.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-54f74f74", Component.options)
  } else {
    hotAPI.reload("data-v-54f74f74", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wULM":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* style the userImage to fit in nav */\n.toolbar-title-img {\n  max-width: 35px;\n  border-radius: 50%;\n}\n.main-viewport {\n  margin-left: 80px;\n  margin-top: 64px;\n}\n", ""]);

// exports


/***/ }),

/***/ "xD1W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPerson_vue__ = __webpack_require__("spdE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5164f0e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPerson_vue__ = __webpack_require__("TrJJ");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("P87o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPerson_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5164f0e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPerson_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/People/AddPerson.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5164f0e6", Component.options)
  } else {
    hotAPI.reload("data-v-5164f0e6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xDPB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateSelectedPersonSkillsRating; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setSelectedPersonSkillsRating; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updatePersonSkillsRating; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_service_database_js__ = __webpack_require__("LLs5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store___ = __webpack_require__("IcnI");




function updateSelectedPersonSkillsRating(skillsRating) {
	var personKey = __WEBPACK_IMPORTED_MODULE_2__store___["a" /* default */].getters.selectedPersonKey;
	var personRef = __WEBPACK_IMPORTED_MODULE_1__vue_service_database_js__["h" /* skillsRatingRef */].child("byPerson").child(personKey);
	//personRef.child("skills").set(skillsRating);
	personRef.child("skills").set(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(skillsRating)));
	personRef.child("skills").once("value").then(function (snapshot) {
		var updatedSkillsRating = snapshot.val();
		__WEBPACK_IMPORTED_MODULE_2__store___["a" /* default */].dispatch("SET_SELECTED_PERSON_SKILLS_RATING", updatedSkillsRating);
	});
}
function updatePersonSkillsRating(personKey, skillsRating) {
	var personRef = __WEBPACK_IMPORTED_MODULE_1__vue_service_database_js__["h" /* skillsRatingRef */].child("byPerson").child(personKey);
	//personRef.child("skills").set(skillsRating);
	personRef.child("skills").set(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(skillsRating)));
	personRef.child("skills").once("value").then(function (snapshot) {
		var updatedSkillsRating = snapshot.val();
		__WEBPACK_IMPORTED_MODULE_2__store___["a" /* default */].dispatch("SET_SELECTED_PERSON_SKILLS_RATING", updatedSkillsRating);
	});
}
function setSelectedPersonSkillsRating(personKey) {
	var person = __WEBPACK_IMPORTED_MODULE_2__store___["a" /* default */].getters.skillsRatingByPerson[personKey];
	var skillsRating = {};
	if (person) {
		skillsRating = person.skills;
	}
	__WEBPACK_IMPORTED_MODULE_2__store___["a" /* default */].dispatch("SET_SELECTED_PERSON_SKILLS_RATING", skillsRating);
}



/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_service_auth__ = __webpack_require__("EREM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NavItems_vue__ = __webpack_require__("CkpQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Navigation_vue__ = __webpack_require__("bwGm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_guard__ = __webpack_require__("CkWL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store___ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vue_service_selected_person__ = __webpack_require__("MsY1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vue_service_database__ = __webpack_require__("LLs5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vue_service_api__ = __webpack_require__("CBkA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vue_service_person__ = __webpack_require__("h8tr");

//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  components: {
    "nav-items": __WEBPACK_IMPORTED_MODULE_3__components_NavItems_vue__["a" /* default */],
    "nav-gation": __WEBPACK_IMPORTED_MODULE_4__components_Navigation_vue__["a" /* default */]
  },
  computed: {
    authenticated: function authenticated() {
      return this.$store.getters.authenticated;
    },
    user: function user() {
      return this.$store.getters.user;
    },
    administrator: function administrator() {
      return this.$store.getters.administrator;
    }
  },
  created: function created() {
    var _this = this;

    /* EVENT LISTENERS */
    // Listen for changes to the users auth state
    __WEBPACK_IMPORTED_MODULE_2__vue_service_auth__["a" /* auth */].onAuthStateChanged(function (user) {
      if (user != null) {
        // Update the store
        _this.$store.dispatch("SET_AUTHORIZED", user);
        _this.$store.dispatch("SET_USER", user);
        _this.$store.dispatch("SET_ADMINISTRATOR", {
          user: user,
          administratorsEmail: __WEBPACK_IMPORTED_MODULE_8__vue_service_database__["a" /* administratorsRef */] // WHAT?? <<
        });

        // Get a token to validate Firebase API request
        user.getIdToken().then(function (token) {
          _this.$store.dispatch("SET_TOKEN", token);

          // Ask firebase functions to get data
          // from external services via their apis
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__vue_service_api__["a" /* syncApis */])();
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__vue_service_api__["b" /* postToday */])();
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__vue_service_api__["c" /* updatePersonsGSuiteStatus */])();
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__vue_service_api__["d" /* postGroupsData */])();
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__vue_service_api__["e" /* postOnsipUsers */])();
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__vue_service_api__["f" /* postSlackActiveUsers */])();
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__vue_service_api__["g" /* updateSlackActiveUsersPublicChannels */])();
        });

        // The user will see their own info when the app starts

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__vue_service_selected_person__["a" /* setUserAsSelectedPerson */])(user);

        // Log the user.email and timestamp in the Database
        // ?? This should be a cloud functions ??
        // !! TODO: Clean up this log above (it's filling up Firebase)
        var date = new Date();
        __WEBPACK_IMPORTED_MODULE_8__vue_service_database__["b" /* usersRef */].push({ email: user.email, time: date.getTime() });
      } else {
        console.log("auth.currentUser :", __WEBPACK_IMPORTED_MODULE_2__vue_service_auth__["a" /* auth */].currentUser);
        // No user/auth so update the store to revoke access
        __WEBPACK_IMPORTED_MODULE_6__store___["a" /* default */].dispatch("SET_AUTHORIZED", false);
        // Remove user data from the store
        __WEBPACK_IMPORTED_MODULE_6__store___["a" /* default */].dispatch("SET_USER", false);
        // Send to signin page
        _this.$router.push("/");
      }
    });
    var promises = [];
    // Listen to the realtime database and
    // update the store when it changes
    var p = __WEBPACK_IMPORTED_MODULE_8__vue_service_database__["c" /* peopleRef */].on("value", function (snapshot) {
      console.log("Loaded people");
      var value = snapshot.val();
      _this.$store.dispatch("SET_PEOPLE", value);
    });
    promises.push(p);
    var g = __WEBPACK_IMPORTED_MODULE_8__vue_service_database__["d" /* groupsRef */].on("value", function (snapshot) {
      var value = snapshot.val();
      _this.$store.dispatch("SET_GROUPS", value);
    });
    promises.push(g);
    var m = __WEBPACK_IMPORTED_MODULE_8__vue_service_database__["e" /* membershipsRef */].on("value", function (snapshot) {
      var value = snapshot.val();
      _this.$store.dispatch("SET_MEMBERSHIPS", value);
    });
    promises.push(m);
    var a = __WEBPACK_IMPORTED_MODULE_8__vue_service_database__["a" /* administratorsRef */].on("value", function (snapshot) {
      console.log("Loaded admins");
      _this.$store.dispatch("SET_ADMINISTRATOR", {
        user: _this.$store.getters.user,
        administratorsEmail: __WEBPACK_IMPORTED_MODULE_8__vue_service_database__["a" /* administratorsRef */]
      });
    });
    promises.push(a);
    var b = __WEBPACK_IMPORTED_MODULE_8__vue_service_database__["f" /* birthdaysThisMonthRef */].on("value", function (snapshot) {
      console.log("Loaded birthdays");
      var value = snapshot.val();
      _this.$store.dispatch("SET_BIRTHDAYS_THIS_MONTH", value);
    });
    promises.push(b);
    var an = __WEBPACK_IMPORTED_MODULE_8__vue_service_database__["g" /* anniversariesThisMonthRef */].on("value", function (snapshot) {
      console.log("Loaded anniversaries");
      var value = snapshot.val();
      _this.$store.dispatch("SET_ANNIVERSARIES_THIS_MONTH", value);
    });
    promises.push(an);
    __WEBPACK_IMPORTED_MODULE_8__vue_service_database__["h" /* skillsRatingRef */].child("byTechnology").once("value", function (snapshot) {
      console.log("Loaded skill ratings");
      var value = snapshot.val();
      _this.$store.dispatch("SET_SKILLS_RATING_BY_TECHNOLOGY", value);
    });
    var s = __WEBPACK_IMPORTED_MODULE_8__vue_service_database__["h" /* skillsRatingRef */].child("byPerson").on("value", function (snapshot) {
      console.log("Loaded skills ratings");
      var skillsRatingByPerson = snapshot.val();
      //console.log("skillsRatingByPerson", skillsRatingByPerson)
      _this.$store.dispatch("SET_SKILLS_RATING_BY_PERSON", skillsRatingByPerson);
    });
    promises.push(s);
    var t = __WEBPACK_IMPORTED_MODULE_8__vue_service_database__["i" /* technologyRef */].on("value", function (snapshot) {
      console.log("Loaded technology");
      var value = snapshot.val();
      _this.$store.dispatch("SET_TECHNOLOGY", value);
    });
    promises.push(t);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises);
  }
});

/***/ }),

/***/ "z/SG":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.icon-space[data-v-71fef2af] {\n  margin-right: 10px;\n  margin-bottom: 0px;\n  padding-right: 10px;\n  padding-bottom: 0px;\n}\n.people-cards[data-v-71fef2af]{\n  display: flex;\n  flex-wrap: wrap;\n}\n.person-card[data-v-71fef2af]{\n  width: 13.2%;\n  margin-right: 1.166%;\n  margin-bottom: 20px;\n  cursor: pointer;\n}\n.person-card[data-v-71fef2af]:nth-child(7n){\n  margin-right: 0px;\n}\n.person-image-holder[data-v-71fef2af]{\n  padding: 10%;\n  width: 100%;\n}\n.person-image[data-v-71fef2af]{\n  width: 100%;\n  border-radius: 50%;\n}\n.person-card-content[data-v-71fef2af]{\n  width: 100%;\n  text-align: center;\n}\n.person-name[data-v-71fef2af]{\n  font-weight: bold;\n}\n.person-job[data-v-71fef2af]{\n  font-weight: 300;\n  color: rgba(0, 0, 0, 0.6);\n  padding-bottom: 10px;\n}\n.person-display[data-v-71fef2af]{\n  margin: -20px -25px 0px 55px;\n  height: 100%;\n}\n.person-content[data-v-71fef2af]{\n  padding-top: 80px;\n}\n", ""]);

// exports


/***/ }),

/***/ "zdgG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c("v-flex", { attrs: { xs12: "", md6: "" } }, [
                _c("h2", [_vm._v("Accounts")])
              ]),
              _vm._v(" "),
              _c(
                "v-flex",
                { staticClass: "pt-3", attrs: { xs12: "", md6: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      name: "search-1",
                      label: "Search",
                      id: "search",
                      "append-icon": "search"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc198ee2", esExports)
  }
}

/***/ }),

/***/ "zqmC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Projects_vue__ = __webpack_require__("P0G/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cce41e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Projects_vue__ = __webpack_require__("Fxs+");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("64p4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0cce41e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Projects_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cce41e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Projects_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Projects/Projects.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0cce41e2", Component.options)
  } else {
    hotAPI.reload("data-v-0cce41e2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.cd1fa11042c7142b4b10.js